/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable id-length */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable no-multiple-empty-lines */
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { createPortal, flushSync } from 'react-dom';
import { TableUtility } from '@utility/dynamic-table';
import { Navigate } from 'react-router-dom';
import ExcelJS from 'exceljs';
import { useAuth } from '../../../Hooks/useAuth';
import UseAxios from '../../../Api/http/http';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import CustomStyledDatePicker from '../../../Components/Datepicker/CustomStyledDatePicker';
import dayjs from 'dayjs';
import lottie from 'lottie-web';
import { toast } from 'react-toastify';
import { serviceName } from '../../../Api/resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../../Api/resources/serviceURLs';
import {
  getStaffingRequests,
  createTbhResourceAllocation,
  updateTbhResourceAllocation,
  deleteTbhResourceAllocation,
  getResourceTypes,
  getRoleExperienceMappings,
  updateBulkTbhResourceAllocation,
} from '../../../Api/request/projectDetails';
import { tbhEmployeeManagementFilters, getTbhDetailsByTbhId } from '../../../Api/request/tbhEmployeeManagement';
import {
  createResourceAllocation,
  updateResourceAllocation,
  deleteResourceAllocation,
  getScrums,
  exportResourceAllocation,
  getResourceAllocationList,
  getResourceAllocationProjectDetails,
  getTbhResourceAllocations,
  getTbhIdsList,
  getEmployeesList,
  getDepartmentsList,
  getRegionCountryMapping,
  getVerticalNames,
  getExperienceLevels,
  getLocationTypes,
  updateBulkResourceAllocation,
} from '../../../Api/request/resourceAllocation';
import editIcon from '../../../Assets/images/svg/dar_edit.svg';
import deleteIcon from '../../../Assets/images/svg/dar_delete.svg';
import resumeDownloadIcon from '../../../Assets/images/svg/resume_download.svg';
import { InputTextarea } from 'primereact/inputtextarea';
import './ResourceAllocation.scss';
import { Skeleton } from 'primereact/skeleton';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import CustomDatePicker from '../../Delivery/ProjectDetails/customDatePicker';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const fetchProjectBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const path = '/v1/resource-allocation-resource';
  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }
  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};
const RA_TOOLBAR_BASE_URL = fetchProjectBaseURL();

const downloadToastBaseStyle = {
  color: '#ffffff',
  borderRadius: '8px',
  minHeight: '102px',
  width: '312px',
  boxShadow: '0 10px 24px rgba(26, 39, 68, 0.18)',
};

const downloadToastProgressStyle = {
  background: 'rgba(43, 228, 99, 0.9)',
};

const renderDownloadToastContent = (title, message) => (
  <div className="ra-download-toast">
    <div className="ra-download-toast__title">{title}</div>
    <div className="ra-download-toast__message">{message}</div>
  </div>
);

const showDownloadSuccessToast = () => toast.success(
  renderDownloadToastContent(
    'Download Successful',
    'The data has been successfully exported to Excel.',
  ),
  {
    position: 'top-center',
    autoClose: 3000,
    style: {
      ...downloadToastBaseStyle,
      background: '#35bf72',
    },
    progressStyle: downloadToastProgressStyle,
  },
);

const showDownloadFailureToast = (message) => toast.error(
  renderDownloadToastContent('Download Failed', message),
  {
    position: 'top-center',
    autoClose: 3000,
    style: {
      ...downloadToastBaseStyle,
      background: '#c34444',
    },
    progressStyle: {
      background: 'rgba(255, 111, 86, 0.9)',
    },
  },
);

const getAllocationIntegrationResults = (response) => (
  response?.data?.integrationResults
  || response?.integrationResults
  || response?.data?.data?.integrationResults
  || response?.data?.data?.resourceAllocation?.integrationResults
  || null
);

const toastAllocationIntegrationResults = (response) => {
  const results = getAllocationIntegrationResults(response);
  if (!results) return;

  [results.jira, results.projectDl].forEach((result) => {
    if (!result?.message || result.status === 'skipped') return;
    if (result.status === 'success') {
      toast.success(result.message);
    } else {
      toast.warning(result.message);
    }
  });
};

const sanitizeSheetName = (value, fallback) => {
  const cleaned = String(value || fallback || 'Sheet')
    .replace(/[:\\/?*[\]]/g, ' ')
    .trim()
    .slice(0, 31);
  return cleaned || fallback || 'Sheet';
};

const downloadWorkbook = async ({ fileName, sheets }) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Darpan 2';
  workbook.created = new Date();
  workbook.modified = new Date();
  workbook.title = fileName;

  sheets.forEach((sheet) => {
    const worksheet = workbook.addWorksheet(sanitizeSheetName(sheet.sheetName, sheet.title));
    const columns = (sheet.tableConfiguration || []).map((column) => ({
      header: column.header,
      key: column.field,
      width: Math.max(15, Math.min(35, Number(column.width) / 6 || 24)),
    }));
    worksheet.columns = columns;
    worksheet.getRow(1).font = { bold: true };
    (sheet.tableData || []).forEach((row) => worksheet.addRow(row));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const normalizeExportRowKey = (value) => String(value ?? '')
  .trim()
  .toLowerCase();

const orderRowsByVisibleTable = (exportRows = [], visibleRows = [], key) => {
  const exportRowsByKey = exportRows.reduce((acc, row) => {
    const rowKey = normalizeExportRowKey(row?.[key]);
    if (!acc.has(rowKey)) acc.set(rowKey, []);
    acc.get(rowKey).push(row);
    return acc;
  }, new Map());

  const orderedRows = [];
  visibleRows.forEach((row) => {
    const rowKey = normalizeExportRowKey(row?.[key]);
    const matchedRows = exportRowsByKey.get(rowKey);
    if (matchedRows?.length) {
      orderedRows.push(matchedRows.shift());
    }
  });

  const remainingRows = Array.from(exportRowsByKey.values()).flat();
  return [...orderedRows, ...remainingRows];
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const PAST_ALLOCATION_DELETE_MESSAGE = 'Allocations with a start date before today cannot be deleted';

const isAllocationStartDateBeforeToday = (startDate) => {
  if (!startDate) return false;
  return dayjs(startDate)
    .startOf('day')
    .isBefore(dayjs().startOf('day'));
};

const getTbhAllocationCalendarDays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 0;
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  if (start.getTime() > end.getTime()) return 0;
  return Math.floor((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000)) + 1;
};

const getTbhAllocatedDays = (row) => {
  const explicitDays = Number(row?.allocated_days ?? row?.allocatedDays);
  if (Number.isFinite(explicitDays) && explicitDays > 0) {
    return explicitDays;
  }

  const allocationPct = Number(row?.allocation_pct ?? row?.allocationPct ?? row?.billability ?? row?.allocation ?? 0);
  const startDate = row?.allocation_start_date || row?.allocationStartDate || row?.start_date || row?.startDate || '';
  const endDate = row?.allocation_end_date || row?.allocationEndDate || row?.end_date || row?.endDate || '';
  const totalDays = Number(row?.tot_days ?? row?.totDays ?? getTbhAllocationCalendarDays(startDate, endDate));

  if (!Number.isFinite(totalDays) || totalDays <= 0) return 0;
  return Number(((totalDays * Math.max(0, Math.min(100, allocationPct))) / 100).toFixed(2));
};

const getTbhAllocatedHours = (row, allocatedDays) => {
  const explicitHours = Number(row?.allocated_hours ?? row?.allocatedHours);
  if (Number.isFinite(explicitHours) && explicitHours > 0) {
    return explicitHours;
  }
  return Number((Number(allocatedDays || 0) * 8).toFixed(2));
};

const updateRoleAndResetExperience = (setForm, roleId) => {
  flushSync(() => {
    setForm((prev) => ({
      ...prev,
      roleId: roleId ? String(roleId) : '',
      experience: '',
    }));
  });
};

const normalizeExperienceLabel = (value) => String(value ?? '')
  .trim()
  .replace(/\s*(yrs?|years?)$/i, '')
  .replace(/\s*-\s*/g, '-')
  .replace(/\s*\+\s*$/g, '+')
  .replace(/\s+/g, ' ');

const getExperienceSortParts = (value) => {
  const label = normalizeExperienceLabel(value).toLowerCase();
  const compactLabel = label.replace(/[\s_-]/g, '');

  if (compactLabel === 'junior') return { group: 1, start: 0, end: 0 };
  if (compactLabel === 'midlevel') return { group: 1, start: 1, end: 1 };
  if (compactLabel === 'senior') return { group: 1, start: 2, end: 2 };

  const rangeMatch = label.match(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)/);
  if (rangeMatch) {
    return { group: 0, start: Number(rangeMatch[1]), end: Number(rangeMatch[2]) };
  }

  const plusMatch = label.match(/^(\d+(?:\.\d+)?)\+$/);
  if (plusMatch) {
    return { group: 0, start: Number(plusMatch[1]), end: Number(plusMatch[1]) };
  }

  const numericMatch = label.match(/^(\d+(?:\.\d+)?)$/);
  if (numericMatch) {
    return { group: 2, start: Number(numericMatch[1]), end: Number(numericMatch[1]) };
  }

  return { group: 3, start: 0, end: 0 };
};

const sortExperienceOptions = (options = [], getLabel = (option) => option?.label ?? option) => (
  [...options].sort((first, second) => {
    const firstLabel = normalizeExperienceLabel(getLabel(first));
    const secondLabel = normalizeExperienceLabel(getLabel(second));
    const firstSort = getExperienceSortParts(firstLabel);
    const secondSort = getExperienceSortParts(secondLabel);

    return firstSort.group - secondSort.group
      || firstSort.start - secondSort.start
      || firstSort.end - secondSort.end
      || firstLabel.localeCompare(secondLabel, undefined, { numeric: true, sensitivity: 'base' });
  })
);

const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
};

const EMPTY_ALLOCATION_FORM = {
  requestId: '',
  empId: '',
  resourceType: '',
  technology: '',
  billability: 100,
  efforts: 100,
  startDate: null,
  endDate: null,
  isShadow: false,
  scrumId: '',
  remarks: '',
};

const EMPTY_TBH_FORM = {
  requestId: '',
  tbhId: '',
  roleId: '',
  allocationPct: '',
  allocationStartDate: null,
  allocationEndDate: null,
  scrumId: '',
  remark: '',
  verticalId: '',
  regionId: '',
  countryId: '',
  experience: '',
  locationId: '',
  departmentId: '',
};

const ROW_SELECTOR_COLUMN = { field: 'rowSelector', header: ' ', visible: true, width: 45, sortable: false };

const BASE_ALLOCATION_TABLE_COLUMNS = [
  { field: 'role', header: 'Role', visible: true, width: 120, sortable: true },
  { field: 'status', header: 'Allocation Status', visible: true, width: 150, sortable: true },
  { field: 'resourceName', header: 'Employee Name', visible: true, width: 180, sortable: true },
  { field: 'employeeId', header: 'Employee ID', visible: true, width: 120, sortable: true },
  { field: 'skills', header: 'Technology', visible: true, width: 180, sortable: true },
  { field: 'allocationPct', header: 'Allocation %', visible: true, width: 120, sortable: true },
  { field: 'startDate', header: 'Allocation Start Date', visible: true, width: 160, sortable: true },
  { field: 'endDate', header: 'Allocation End Date', visible: true, width: 160, sortable: true },
  { field: 'remarks', header: 'Comments', visible: true, width: 180, sortable: true, ellipsis: true },
  { field: 'scrumName', header: 'Scrum', visible: true, width: 120, sortable: true },
];

const ALLOCATION_ACTION_COLUMN = { field: 'action', header: 'Action', visible: true, width: 100, sortable: false };

const BASE_TBH_TABLE_COLUMNS = [
  { field: 'tbhId', header: 'TBH Id', visible: true, width: 110, sortable: true },
  { field: 'projectName', header: 'Project Name', visible: true, width: 160, sortable: true },
  { field: 'staffingRequest', header: 'Staffing Request', visible: true, width: 150, sortable: true },
  { field: 'vertical', header: 'Employee Vertical', visible: true, width: 150, sortable: true },
  { field: 'region', header: 'Employee Region', visible: true, width: 130, sortable: true },
  { field: 'country', header: 'Employee Country', visible: true, width: 130, sortable: true },
  { field: 'role', header: 'Role', visible: true, width: 130, sortable: true },
  { field: 'experience', header: 'Employee Experience', visible: true, width: 120, sortable: true },
  { field: 'location', header: 'Location', visible: true, width: 120, sortable: true },
  { field: 'department', header: 'Department', visible: true, width: 130, sortable: true },
  { field: 'allocationPct', header: 'Allocation %', visible: true, width: 120, sortable: true },
  { field: 'startDate', header: 'Allocation Start Date', visible: true, width: 160, sortable: true },
  { field: 'endDate', header: 'Allocation End Date', visible: true, width: 160, sortable: true },
  { field: 'allocatedDays', header: 'Allocated Days', visible: true, width: 120, sortable: true },
  { field: 'allocatedHours', header: 'Allocated Hours', visible: true, width: 120, sortable: true },
  { field: 'comments', header: 'Comments', visible: true, width: 180, sortable: true, ellipsis: true },
  { field: 'scrumName', header: 'Scrum', visible: true, width: 120, sortable: true },
];

const TBH_ACTION_COLUMN = { field: 'action', header: 'Action', visible: true, width: 100, sortable: false };

const buildAllocationTableData = (rows, onEdit, onDelete, roleTypes = [], scrumList = [], permissions = {}, selectedIds = [], setSelectedIds) => {
  return rows.map((row) => {
    const isPast = row.endDate && new Date(row.endDate) < new Date();
    const isDeleteRestricted = isAllocationStartDateBeforeToday(row.startDate);
    const statusText = isPast ? 'Moved Out' : 'Active';
    const statusClass = isPast ? 'status-moved-out' : 'status-active';

    const matchedRole = roleTypes.find((r) => Number(r.type_id || r.id) === Number(row.resourceType));
    const roleName = matchedRole ? (matchedRole.resource_type || matchedRole.resource_type_name) : (row.resourceType || '');

    const scrumId = row.scrumId || row.scrum_id;
    let scrumName = row.scrumName || '';
    if (!scrumName && scrumId) {
      const matchedScrum = scrumList.find((s) => Number(s.id) === Number(scrumId));
      scrumName = matchedScrum ? (matchedScrum.name || matchedScrum.label) : String(scrumId);
    }
    const isChecked = selectedIds.includes(row.allocationId);

    return {
      ...row,
      rowSelector: (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}
        >
          <input
            type="checkbox"
            checked={isChecked}
            disabled={isPast || !permissions.update}
            style={{ cursor: isPast ? 'not-allowed' : 'pointer' }}
            onChange={(e) => {
              e.stopPropagation();
              if (isPast) return;
              setSelectedIds((prevSelected) =>
                prevSelected.includes(row.allocationId)
                  ? prevSelected.filter((id) => id !== row.allocationId)
                  : [...prevSelected, row.allocationId],
              );
            }}
          />
        </div>
      ),
      role: <span className="allocation-role-text">{roleName}</span>,
      status: (
        <span className={`status-badge ${statusClass}`}>
          {statusText}
        </span>
      ),
      resourceName: <span className="resource-name-text">{row.resourceName || ''}</span>,
      employeeId: row.employeeId || row.empId || '',
      skills: (
        <div className="skills-cell">
          <span className="skills-text">{row.skills || ''}</span>
        </div>
      ),
      allocationPct: (
        <div className="allocation-pct-cell">
          <span className="allocation-pct-text">{row.billability || row.efforts || 0}%</span>
          {row.isShadow === 1 && <div className="shadow-label">shadow</div>}
        </div>
      ),
      startDate: row.startDate ? formatDate(row.startDate) : '',
      endDate: row.endDate ? formatDate(row.endDate) : '',
      remarks: row.remarks || '',
      scrumName,
      action: (
        <div className="allocation-action-cell" onClick={(e) => e.stopPropagation()}>
          {permissions.update && (
            <button type="button" className={`action-btn edit-btn ${isChecked ? 'disabled-action-btn' : ''}`} title="Edit" disabled={isChecked} onClick={() => onEdit(row)}>
              <img src={editIcon} alt="Edit" className="action-icon" style={{ opacity: isChecked ? 0.4 : 1 }} />
            </button>
          )}
          {permissions.delete && (
            <button
              type="button"
              className={`action-btn delete-btn ${isChecked ? 'disabled-action-btn' : ''} ${isDeleteRestricted ? 'past-allocation-delete-btn' : ''}`}
              title={isDeleteRestricted ? PAST_ALLOCATION_DELETE_MESSAGE : 'Delete'}
              aria-disabled={isChecked || isDeleteRestricted}
              onClick={() => onDelete(row)}
              disabled={isChecked}
            >
              <img src={deleteIcon} alt="Delete" className="action-icon" style={{ opacity: isChecked || isDeleteRestricted ? 0.4 : 1 }} />
            </button>
          )}
        </div>
      ),
    };
  });
};

const buildTbhTableData = (
  rows,
  onEdit,
  onDelete,
  projectList = [],
  projectMetadata = null,
  tbhFilters = {},
  roleTypes = [],
  scrumList = [],
  permissions = {},
  mappingData = [],
  expLevels = [],
  locationTypes = [],
  selectedIds = [],
  setSelectedIds,
) => {
  return (rows || []).map((row) => {
    const isDeleteRestricted = isAllocationStartDateBeforeToday(row.allocationStartDate);
    const project = (projectList || []).find((p) => Number(p?.project?.projectId || p?.project_id || p?.projectId || p?.id) === Number(row.projectId || row.project_id));
    let projectName = row.projectName || (project ? (project.project?.projectName || project.project_name || project.projectName || project.name) : '') || '';

    if (!projectName && projectMetadata && Number(projectMetadata.projectId || projectMetadata.project_id || projectMetadata.id) === Number(row.projectId || row.project_id)) {
      projectName = projectMetadata.projectName || projectMetadata.project_name || '';
    }

    let roleName = row.role || '';
    if (!roleName || typeof roleName === 'number' || !isNaN(Number(roleName))) {
      const matchedRole = roleTypes.find((r) => Number(r.type_id || r.id) === Number(row.roleId || row.role));
      if (matchedRole) {
        roleName = matchedRole.resource_type || matchedRole.resource_type_name;
      }
    }

    let verticalName = row.vertical || '';
    const vId = Number(row.verticalId || row.vertical_id);
    if (!verticalName && !isNaN(vId)) {
      const matchedVertical = tbhFilters?.employeeVerticals?.find((v) => Number(v.value) === vId);
      if (matchedVertical) {
        verticalName = matchedVertical.label;
      }
    }

    // Handle region and country - check for regionCountryMappingId first
    let regionName = '';
    let countryName = '';

    const mappingId = row.regionCountryMappingId || row.region_country_mapping_id;
    if (mappingId) {
      const mapping = (mappingData || []).find((rc) => Number(rc.id) === Number(mappingId));
      if (mapping) {
        regionName = mapping.region_name || '';
        countryName = mapping.country_name || '';
      }
    }

    // Fallback to direct region lookup if not found via mapping
    if (!regionName) {
      const rawRegion = row.regionId ?? row.region_id ?? row.region ?? '';
      const rId = Number(rawRegion);
      if (!isNaN(rId) && rId > 0) {
        const matchedRegion = (mappingData || []).find((rc) => Number(rc.region_id) === rId);
        if (matchedRegion) regionName = matchedRegion.region_name;
      }
      if (!regionName && typeof rawRegion === 'string' && isNaN(Number(rawRegion))) {
        regionName = rawRegion;
      }
    }

    // Fallback to direct country lookup if not found via mapping
    if (!countryName) {
      const rawCountry = row.countryId ?? row.country_id ?? row.country ?? '';
      const cId = Number(rawCountry);
      if (!isNaN(cId) && cId > 0) {
        const matchedCountry = (mappingData || []).find((rc) => Number(rc.country_id) === cId);
        if (matchedCountry) countryName = matchedCountry.country_name;
      }
      if (!countryName && typeof rawCountry === 'string' && isNaN(Number(rawCountry))) {
        countryName = rawCountry;
      }
    }

    let experienceRange = row.experience || '';
    const rawExpId = row.experienceId ?? row.experience_id ?? row.res_exp_id;
    const expId = Number(rawExpId);
    if (!experienceRange && !isNaN(expId) && expId > 0) {
      const matchedExp = (expLevels || []).find((value) => Number(value.id) === expId);
      if (matchedExp) experienceRange = matchedExp.experience_range || '';
    }
    if (!experienceRange && typeof row.experience === 'string' && isNaN(Number(row.experience))) {
      experienceRange = row.experience;
    }

    let locationName = row.location || '';
    const rawLocationId = row.locationId ?? row.location_id;
    const locationId = Number(rawLocationId);
    if (!locationName && !isNaN(locationId) && locationId > 0) {
      const matchedLocation = (locationTypes || []).find((value) => Number(value.id) === locationId);
      if (matchedLocation) locationName = matchedLocation.location_type || '';
    }
    if (!locationName && typeof row.location === 'string' && isNaN(Number(row.location))) {
      locationName = row.location;
    }

    const scrumId = row.scrumTeamId || row.scrum_team_id || row.scrumId;
    const matchedScrum = scrumList.find((s) => Number(s.id) === Number(scrumId));
    const scrumName = matchedScrum ? (matchedScrum.name || matchedScrum.label) : (row.scrumName || scrumId || '');
    const allocatedDays = getTbhAllocatedDays(row);
    const allocatedHours = getTbhAllocatedHours(row, allocatedDays);

    const targetId = row.id;
    const isChecked = selectedIds.includes(targetId);

    return {
      ...row,
      rowSelector: (
        <input
          disabled={!permissions.update}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            if (isChecked) {
              setSelectedIds(selectedIds.filter(id => id !== targetId));
            } else {
              setSelectedIds([...selectedIds, targetId]);
            }
          }}
        />
      ),
      tbhId: row.tbhId || (row.id ? `TBH-${row.id}` : ''),
      projectName,
      staffingRequest: row.staffingRequest || (row.requestId || row.request_id ? `SRN-${row.requestId || row.request_id}` : '') || '',
      vertical: verticalName,
      region: regionName,
      country: countryName,
      role: roleName,
      experience: experienceRange,
      location: locationName,
      department: row.department || '',
      allocationPct: row.allocationPct ? (String(row.allocationPct).endsWith('%') ? row.allocationPct : `${row.allocationPct}%`) : '0%',
      startDate: row.allocationStartDate ? formatDate(row.allocationStartDate) : '',
      endDate: row.allocationEndDate ? formatDate(row.allocationEndDate) : '',
      allocatedDays: Number(allocatedDays).toFixed(2),
      allocatedHours: Number(allocatedHours).toFixed(2),
      comments: row.remark || row.remarks || '',
      scrumName,
      action: (
        <div className="allocation-action-cell" onClick={(e) => e.stopPropagation()}>
          {permissions.update && (
            <button type="button" className={`action-btn edit-btn ${isChecked ? 'disabled-action-btn' : ''}`} title="Edit" onClick={() => onEdit(row)} disabled={isChecked}>
              <img src={editIcon} alt="Edit" className="action-icon" style={{ opacity: isChecked ? 0.4 : 1 }} />
            </button>
          )}
          {permissions.delete && (
            <button
              type="button"
              className={`action-btn delete-btn ${isDeleteRestricted ? 'past-allocation-delete-btn' : ''}`}
              title={isDeleteRestricted ? PAST_ALLOCATION_DELETE_MESSAGE : 'Delete'}
              aria-disabled={isDeleteRestricted}
              onClick={() => onDelete(row)}
            >
              <img src={deleteIcon} alt="Delete" className="action-icon" style={{ opacity: isDeleteRestricted ? 0.4 : 1 }} />
            </button>
          )}
        </div>
      ),
    };
  });
};


const ResourceAllocation = () => {
  const { userProfile } = useAuth();

  const permissions = useMemo(() => {
    const rawActions = userProfile?.permissions?.['resource:resource-allocation']
      || userProfile?.permissions?.['resource:resource_allocation']
      || [];
    return {
      read: rawActions.includes('read') || userProfile?.isAdmin || userProfile?.superAdmin,
      create: rawActions.includes('create') || userProfile?.isAdmin || userProfile?.superAdmin,
      update: rawActions.includes('update') || userProfile?.isAdmin || userProfile?.superAdmin,
      delete: rawActions.includes('delete') || userProfile?.isAdmin || userProfile?.superAdmin,
    };
  }, [userProfile]);

  if (!permissions.read) {
    return <Navigate to="/home" replace />;
  }

  // States
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [projectList, setProjectList] = useState([]);
  const [projectMetadata, setProjectMetadata] = useState(null);
  const [allocations, setAllocations] = useState([]);
  const [tbhAllocations, setTbhAllocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [exportHostElement, setExportHostElement] = useState(null);

  // Dropdown Master Options
  const [employeeMaster, setEmployeeMaster] = useState([]);
  const [roleTypes, setRoleTypes] = useState([]);
  const [scrumList, setScrumList] = useState([]);
  const [tbhFilters, setTbhFilters] = useState({
    employeeVerticals: [],
    employeeRoles: [],
    regionCountries: [],
  });
  const [regionCountryMapping, setRegionCountryMapping] = useState([]);
  const [locationTypes, setLocationTypes] = useState([]);
  const [staffingRequests, setStaffingRequests] = useState([]);
  const [tbhIdsMaster, setTbhIdsMaster] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [experienceLevel, setexperienceLevel] = useState([]);
  const [roleExperienceMappings, setRoleExperienceMappings] = useState([]);
  const [selectedResourceRowDetails, setSelectedResourceRowDetails] = useState([]);
  const [selectedTbhRowDetails, setSelectedTbhRowDetails] = useState([]);

  // Refs
  const lottieContainerRef = useRef(null);
  const lottieAnimRef = useRef(null);
  const isInitialToolbarLoadRef = useRef(true);
  const selectedProjectIdRef = useRef('');
  const hasActiveFiltersRef = useRef(false);
  const initialProjectListRef = useRef([]);
  const projectListRef = useRef([]);
  const hiddenExportUtilityRef = useRef(null);
  const tbhManualSelectionRef = useRef({
    roleId: false,
    experience: false,
  });

  useEffect(() => {
    selectedProjectIdRef.current = selectedProjectId;
  }, [selectedProjectId]);

  // Modals & Forms
  const [allocationModal, setAllocationModal] = useState({ isOpen: false, mode: ACTIONS.ADD, row: null });
  const [tbhModal, setTbhModal] = useState({ isOpen: false, mode: ACTIONS.ADD, row: null });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, type: 'standard', row: null });
  const [warningModal, setWarningModal] = useState({ isOpen: false, message: '' });
  const [allocationBulkChangeModal, setAllocationBulkChangeModal] = useState({ isOpen: false, mode: ACTIONS.EDIT, row: null });
  const [tbhBulkChangeModal, setTbhBulkChangeModal] = useState({ isOpen: false, mode: ACTIONS.EDIT, row: null });
  const [bulkFormData, setBulkFormData] = useState({ endDate: '', comments: '' });
  const [allocationForm, setAllocationForm] = useState(EMPTY_ALLOCATION_FORM);
  const [tbhForm, setTbhForm] = useState(EMPTY_TBH_FORM);
  const [errors, setErrors] = useState({});
  const [tbhAutoPopulated, setTbhAutoPopulated] = useState(false);

  const loadMasters = useCallback(async () => {
    UseAxios(getEmployeesList())
      .then((res) => {
        const empList = res?.data?.data || res?.data?.employees || (Array.isArray(res?.data) ? res.data : []);
        if (empList.length > 0) setEmployeeMaster(empList);
      })
      .catch((err) => console.error('Error loading employee master:', err));

    UseAxios(getResourceTypes())
      .then((res) => {
        const fetchedRoles = res?.data?.resourceTypeList || res?.data?.data || [];
        if (fetchedRoles.length > 0) setRoleTypes(fetchedRoles);
      })
      .catch((err) => console.error('Error loading role types:', err));

    UseAxios(getRoleExperienceMappings())
      .then((res) => {
        const fetchedMappings = res?.data?.roleExperienceMappings
          || res?.data?.data?.roleExperienceMappings
          || res?.data?.data
          || [];
        setRoleExperienceMappings(Array.isArray(fetchedMappings) ? fetchedMappings : []);
      })
      .catch((err) => console.error('Error loading role experience mappings:', err));

    UseAxios(getScrums())
      .then((res) => {
        if (res?.data?.scrumList) setScrumList(res.data.scrumList);
      })
      .catch((err) => console.error('Error loading scrums:', err));

    UseAxios(tbhEmployeeManagementFilters())
      .then((res) => {
        if (res?.data?.data) {
          setTbhFilters((prev) => ({ ...prev, ...res.data.data }));
        }
      })
      .catch((err) => console.error('Error loading tbh filters:', err));

    UseAxios(getRegionCountryMapping())
      .then((res) => {
        if (res?.data?.data) {
          setRegionCountryMapping(res.data.data);
        }
      })
      .catch((err) => console.error('Error loading region country mapping:', err));

    UseAxios(getVerticalNames())
      .then((res) => {
        if (res?.data?.data) {
          setTbhFilters((prev) => ({
            ...prev,
            employeeVerticals: res.data.data,
          }));
        }
      })
      .catch((err) => console.error('Error loading vertical names:', err));

    UseAxios(getDepartmentsList())
      .then((res) => {
        if (res?.data?.departments) setDepartmentsList(res.data.departments);
      })
      .catch((err) => console.error('Error loading departments list:', err));

    UseAxios(getExperienceLevels())
      .then((res) => {
        if (res?.data?.data) {
          setexperienceLevel(res.data.data);
        }
      });

    UseAxios(getLocationTypes())
      .then((res) => {
        if (res?.data?.data) {
          setLocationTypes(res.data.data);
        }
      })
      .catch((err) => console.error('Error loading location types:', err));
  }, []);

  useEffect(() => {
    loadMasters();
  }, [loadMasters]);

  useEffect(() => {
    if (!tbhModal.isOpen) return;

    let cancelled = false;
    // Reload active IDs on every open so status changes are reflected.
    setTbhIdsMaster([]);
    UseAxios(getTbhIdsList())
      .then((res) => {
        if (!cancelled) setTbhIdsMaster(res?.data?.tbhIds || []);
      })
      .catch((err) => console.error('Error loading tbh ids master:', err));

    return () => {
      cancelled = true;
    };
  }, [tbhModal.isOpen]);

  useEffect(() => {
    const getRAToolbarButton = () => {
      const toolbarButtonGroup = document.querySelector('.ra-toolbar-utility .button-group');
      if (!toolbarButtonGroup) return null;
      const toolbarButtons = Array.from(toolbarButtonGroup.querySelectorAll('button, .p-button'));
      return document.querySelector('.ra-toolbar-utility .table-utility-filter-btn')
        || toolbarButtons.find((buttonElement) => {
          const ariaLabel = buttonElement.getAttribute('aria-label');
          const title = buttonElement.getAttribute('title');
          const prTooltip = buttonElement.getAttribute('data-pr-tooltip');
          return buttonElement.querySelector('.pi-filter')
            || (ariaLabel && ariaLabel.toLowerCase().includes('filter'))
            || (title && title.toLowerCase().includes('filter'))
            || (prTooltip && prTooltip.toLowerCase().includes('filter'));
        }) || toolbarButtons[0];
    };

    const updateToolbarState = () => {
      const filterButton = getRAToolbarButton();
      if (filterButton) {
        filterButton.classList.toggle('ra-filter-active', hasActiveFiltersRef.current);
      }
      const buttonGroup = document.querySelector('.ra-toolbar-utility .button-group');
      setExportHostElement((prev) => (prev === buttonGroup ? prev : buttonGroup));
    };

    updateToolbarState();
    const tableContainer = document.querySelector('.ra-toolbar-utility');
    const buttonObserver = new MutationObserver(updateToolbarState);

    if (tableContainer) {
      buttonObserver.observe(tableContainer, { childList: true, subtree: true });
      tableContainer.addEventListener('click', () => requestAnimationFrame(updateToolbarState), true);
    }
    window.updateRAFilterButtonState = updateToolbarState;

    return () => {
      buttonObserver.disconnect();
      delete window.updateRAFilterButtonState;
    };
  }, []);

  useEffect(() => {
    if (selectedProjectId) {
      const loadStaffingReqs = async () => {
        try {
          const res = await UseAxios(getStaffingRequests(selectedProjectId));
          const list = res?.data?.data || res?.data?.staffingRequestList || [];
          setStaffingRequests(Array.isArray(list) ? list : []);
        } catch (err) {
          console.error('Error loading staffing requests:', err);
        }
      };
      loadStaffingReqs();
    } else {
      setStaffingRequests([]);
    }
  }, [selectedProjectId]);

  const refreshProjectData = useCallback(async () => {
    if (!selectedProjectId) {
      setProjectMetadata(null);
      setAllocations([]);
      setTbhAllocations([]);
      return;
    }

    setIsLoading(true);
    try {
      const [metaRes, allocsRes, tbhRes] = await Promise.all([
        UseAxios(getResourceAllocationProjectDetails(selectedProjectId)),
        UseAxios(getResourceAllocationList(selectedProjectId)),
        UseAxios(getTbhResourceAllocations(selectedProjectId, String(Date.now()))),
      ]);

      if (metaRes?.data?.success) setProjectMetadata(metaRes.data.projectDetails || null);
      if (allocsRes?.data?.success) setAllocations(allocsRes.data.resourceAllocationList || []);
      if (tbhRes?.data?.allocationList) setTbhAllocations(tbhRes.data.allocationList || []);
    } catch (err) {
      console.error('Error loading active project data:', err);
    } finally {
      setIsLoading(false);
    }
  }, [selectedProjectId]);

  useEffect(() => {
    refreshProjectData();
    setSelectedResourceRowDetails([]);
    setSelectedTbhRowDetails([]);
  }, [selectedProjectId, refreshProjectData]);

  // Fetch TBH details when TBH ID is selected and auto-populate fields
  useEffect(() => {
    const fetchTbhDetails = async () => {
      if (!tbhForm.tbhId) {
        setTbhAutoPopulated(false);
        return;
      }

      // Skip if already auto-populated to prevent unnecessary API calls
      if (tbhAutoPopulated) {
        return;
      }

      const cleanTbhId = String(tbhForm.tbhId).replace(/^TBH-/, '');

      try {
        const response = await UseAxios(getTbhDetailsByTbhId(cleanTbhId));
        const tbhData = response?.data?.data || response?.data;

        if (tbhData) {
          let hasChanges = false;
          const nextValues = {};

          if (tbhData.regionId && tbhData.countryId) {
            nextValues.regionId = String(tbhData.regionId);
            nextValues.countryId = String(tbhData.countryId);
            hasChanges = true;
          }

          if (tbhData.employeeVerticalId) {
            nextValues.verticalId = String(tbhData.employeeVerticalId);
            hasChanges = true;
          }

          if (tbhData.employeeDepartmentId) {
            nextValues.departmentId = String(tbhData.employeeDepartmentId);
            hasChanges = true;
          }

          if (tbhData.employeeRoleId) {
            nextValues.roleId = String(tbhData.employeeRoleId);
            hasChanges = true;
          }

          if (tbhData.employeeExperienceId) {
            nextValues.experience = String(tbhData.employeeExperienceId);
            hasChanges = true;
          }

          if (tbhData.locationId) {
            nextValues.locationId = String(tbhData.locationId);
            hasChanges = true;
          }

          if (hasChanges) {
            setTbhForm((prev) => {
              const latestTbhId = String(prev.tbhId || '').replace(/^TBH-/, '');

              if (latestTbhId !== cleanTbhId) {
                return prev;
              }

              return {
                ...prev,
                ...nextValues,
                ...(tbhManualSelectionRef.current.roleId ? { roleId: prev.roleId } : {}),
                ...(tbhManualSelectionRef.current.experience ? { experience: prev.experience } : {}),
              };
            });
            setTbhAutoPopulated(true);
          }
        }
      } catch (err) {
        console.error('Error fetching TBH details:', err);
        setTbhAutoPopulated(false);
      }
    };

    fetchTbhDetails();
  }, [tbhForm.tbhId, tbhAutoPopulated]);

  const isFpp = useMemo(() => {
    if (!projectMetadata) return false;
    const typeStr = String(projectMetadata.type || '').toUpperCase();
    const verticalStr = String(projectMetadata.vertical || '').toUpperCase();
    return typeStr.includes('FPP') || verticalStr.includes('FPP');
  }, [projectMetadata]);

  const tbhIdOptions = useMemo(() => {
    const fromMaster = (tbhIdsMaster || []).map((id) => ({
      label: String(id),
      value: String(id),
    }));
    const seen = new Set(fromMaster.map((opt) => opt.value));
    const deduped = [...fromMaster];
    if (tbhModal.mode === ACTIONS.EDIT && tbhForm.tbhId && !seen.has(tbhForm.tbhId)) {
      deduped.unshift({ label: tbhForm.tbhId, value: tbhForm.tbhId });
    }
    return deduped;
  }, [tbhIdsMaster, tbhForm.tbhId, tbhModal.mode]);

  const departmentOptions = useMemo(() => {
    return (departmentsList || []).map((dept) => ({
      label: dept.dept_name,
      value: String(dept.dept_id),
    }));
  }, [departmentsList]);

  const employeeOptions = useMemo(() => {
    return employeeMaster.map((emp) => {
      const fName = emp.firstName ?? emp.first_name ?? '';
      const lName = emp.lastName ?? emp.last_name ?? '';
      const empId = emp.empId ?? emp.emp_id ?? '';
      return {
        label: `${fName} ${lName}`.trim(),
        value: empId ? String(empId) : '',
      };
    });
  }, [employeeMaster]);

  const roleOptions = useMemo(() => {
    return roleTypes.map((role) => ({
      label: role.resource_type || role.resource_type_name || '',
      value: (role.type_id || role.id) ? String(role.type_id || role.id) : '',
    }));
  }, [roleTypes]);

  const scrumOptions = useMemo(() => {
    return scrumList.map((scrum) => ({
      label: scrum.name,
      value: scrum.id ? String(scrum.id) : '',
    }));
  }, [scrumList]);

  const staffingOptions = useMemo(() => {
    return staffingRequests.map((req) => ({
      label: req.sr_number || `SRN-${req.request_id || req.id}`,
      value: (req.request_id || req.id) ? String(req.request_id || req.id) : '',
    }));
  }, [staffingRequests]);

  const verticalOptions = useMemo(() => {
    return (tbhFilters.employeeVerticals || []).map((v) => ({
      label: v.label || '',
      value: v.value !== undefined && v.value !== null ? String(v.value) : '',
    })).filter(opt => opt.value !== '');
  }, [tbhFilters.employeeVerticals]);

  const regionOptions = useMemo(() => {
    const uniqueRegions = new Map();
    (regionCountryMapping || []).forEach((rc) => {
      if (rc.region_id && !uniqueRegions.has(rc.region_id)) {
        uniqueRegions.set(rc.region_id, {
          label: rc.region_name,
          value: String(rc.region_id),
        });
      }
    });
    return Array.from(uniqueRegions.values());
  }, [regionCountryMapping]);

  const allExperienceOptions = useMemo(() => {
    const experiences = new Map();
    (experienceLevel || []).forEach((exp) => {
      if (exp.id && !experiences.has(exp.id)) {
        experiences.set(exp.id, {
          label: exp.experience_range || exp.experience_range || '',
          value: String(exp.id),
        });
      }
    });
    return Array.from(experiences.values());
  }, [experienceLevel]);

  const roleExperienceIds = useMemo(() => {
    const experiencesByRole = new Map();

    (roleExperienceMappings || []).forEach((mapping, index) => {
      const roleId = String(mapping.roleId ?? mapping.role_id ?? '');
      const experienceId = String(
        mapping.experienceId
          ?? mapping.experience_id
          ?? mapping.experienceCategoryId
          ?? mapping.experience_category_id
          ?? '',
      );

      if (!roleId || !experienceId) return;

      if (!experiencesByRole.has(roleId)) experiencesByRole.set(roleId, new Map());
      experiencesByRole.get(roleId).set(experienceId, index);
    });

    return experiencesByRole;
  }, [roleExperienceMappings]);

  const experienceOptions = useMemo(() => {
    if (!tbhForm.roleId) return [];

    const allowedExperiences = roleExperienceIds.get(String(tbhForm.roleId));
    if (!allowedExperiences) return [];

    return sortExperienceOptions(
      allExperienceOptions.filter((option) => allowedExperiences.has(String(option.value))),
    );
  }, [allExperienceOptions, roleExperienceIds, tbhForm.roleId]);

  const locationOptions = useMemo(() => {
    const locations = new Map();
    (locationTypes || []).forEach((loc) => {
      if (loc.id && !locations.has(loc.id)) {
        locations.set(loc.id, {
          label: loc.location_type || '',
          value: String(loc.id),
        });
      }
    });
    return Array.from(locations.values()).sort(
      (a, b) => Number(a.value) - Number(b.value),
    );
  }, [locationTypes]);

  const countryOptions = useMemo(() => {
    if (!tbhForm.regionId) return [];
    return (regionCountryMapping || [])
      .filter((rc) => String(rc.region_id) === String(tbhForm.regionId))
      .map((rc) => ({
        label: rc.country_name,
        value: String(rc.country_id),
      }));
  }, [regionCountryMapping, tbhForm.regionId]);

  const handleOpenAllocationAdd = () => {
    setAllocationForm(EMPTY_ALLOCATION_FORM);
    setErrors({});
    setAllocationModal({ isOpen: true, mode: ACTIONS.ADD, row: null });
  };

  const handleOpenAllocationBulkChange = () => {
    setAllocationBulkChangeModal({ isOpen: true, mode: ACTIONS.EDIT, row: null });
  };

  const handleOpenTbhBulkChange = () => {
    setTbhBulkChangeModal({ isOpen: true, mode: ACTIONS.EDIT, row: null });
  };

  const handleOpenAllocationEdit = (row) => {
    const selectedStaffing = staffingRequests.find(
      (req) => req.sr_number === row.srNumber
        || `SRN-${req.request_id || req.id}` === row.srNumber
        || Number(req.request_id || req.id) === Number(row.requestId),
    );
    const matchedRole = roleTypes.find(
      (r) =>
        (r.resource_type || r.resource_type_name) === row.resourceType
        || Number(r.type_id || r.id) === Number(row.resourceType),
    );
    const resolvedRoleId = matchedRole ? (matchedRole.type_id || matchedRole.id) : '';
    const rawRow = (allocations || []).find((a) => a.allocationId === row.allocationId);

    setAllocationForm({
      requestId: selectedStaffing ? String(selectedStaffing.request_id || selectedStaffing.id) : '',
      empId: row.empId ? String(row.empId) : '',
      resourceType: resolvedRoleId ? String(resolvedRoleId) : '',
      technology: rawRow ? (rawRow.skills || '') : '',
      billability: row.billability || 100,
      efforts: row.efforts || 100,
      startDate: row.startDate ? dayjs(row.startDate) : null,
      endDate: row.endDate ? dayjs(row.endDate) : null,
      isShadow: row.isShadow === 1 || row.isShadow === true,
      scrumId: row.scrumId ? String(row.scrumId) : '',
      remarks: row.remarks || '',
    });
    setErrors({});
    setAllocationModal({ isOpen: true, mode: ACTIONS.EDIT, row });
  };

  const handleOpenDelete = (type, row) => {
    const startDate = type === 'tbh' ? row.allocationStartDate : row.startDate;
    if (isAllocationStartDateBeforeToday(startDate)) {
      toast.error(PAST_ALLOCATION_DELETE_MESSAGE);
      return;
    }
    setDeleteModal({ isOpen: true, type, row });
  };

  const submitAllocation = async (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!allocationForm.resourceType) nextErrors.resourceType = 'Role is required';
    if (!allocationForm.technology) nextErrors.technology = 'Technology is required';
    if (!allocationForm.empId) nextErrors.empId = 'Employee Name is required';
    if (
      allocationForm.billability === ''
      || allocationForm.billability === null
      || allocationForm.billability === undefined
    ) {
      nextErrors.billability = 'Allocation % is required';
    }
    if (!allocationForm.startDate) nextErrors.startDate = 'Start Date is required';
    if (!allocationForm.endDate) nextErrors.endDate = 'End Date is required';
    if (!allocationForm.scrumId) nextErrors.scrumId = 'Scrum is required';
    if (!allocationForm.remarks) nextErrors.remarks = 'Comments are required';

    if (
      allocationForm.startDate
      && allocationForm.endDate
      && dayjs(allocationForm.startDate).isAfter(dayjs(allocationForm.endDate))
    ) {
      nextErrors.endDate = 'End Date cannot be before Start Date';
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    const selectedStaffing = staffingRequests.find(req => Number(req.request_id || req.id) === Number(allocationForm.requestId));
    const srNumber = selectedStaffing ? (selectedStaffing.sr_number || selectedStaffing.srNumber || `SRN-${selectedStaffing.request_id || selectedStaffing.id}`) : null;

    const payload = {
      projectId: selectedProjectId,
      empId: allocationForm.empId,
      resourceType: allocationForm.resourceType ? Number(allocationForm.resourceType) : null,
      billability: Number(allocationForm.billability),
      efforts: Number(allocationForm.efforts || allocationForm.billability),
      startDate: dayjs(allocationForm.startDate).format('YYYY-MM-DD'),
      endDate: dayjs(allocationForm.endDate).format('YYYY-MM-DD'),
      isShadow: allocationForm.isShadow ? 1 : 0,
      scrumId: allocationForm.scrumId ? Number(allocationForm.scrumId) : null,
      remarks: allocationForm.remarks,
      srNumber: srNumber,
      skills: allocationForm.technology || '',
    };

    setIsLoading(true);
    try {
      let res = null;
      if (allocationModal.mode === ACTIONS.EDIT) {
        res = await UseAxios(updateResourceAllocation(allocationModal.row.allocationId, payload));
      } else {
        res = await UseAxios(createResourceAllocation(payload));
      }

      if (res?.data?.success) {
        toast.success(allocationModal.mode === ACTIONS.EDIT ? 'Resource allocation updated successfully' : 'Resource allocation added successfully');
        if (allocationModal.mode !== ACTIONS.EDIT) {
          toastAllocationIntegrationResults(res);
        }
        setAllocationModal({ isOpen: false, mode: ACTIONS.ADD, row: null });
        refreshProjectData();
      } else {
        const errorMsg = res?.data?.message || res?.data?.response?.data?.message || 'Failed to save resource allocation';
        toast.error(errorMsg);
      }
    } catch (err) {
      console.error('Error submitting allocation:', err);
      toast.error('Error submitting allocation');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenTbhAdd = () => {
    tbhManualSelectionRef.current = {
      roleId: false,
      experience: false,
    };
    setTbhForm(EMPTY_TBH_FORM);
    setErrors({});
    setTbhAutoPopulated(false);
    setTbhModal({ isOpen: true, mode: ACTIONS.ADD, row: null });
  };

  const handleOpenTbhEdit = (row) => {
    tbhManualSelectionRef.current = {
      roleId: false,
      experience: false,
    };
    const rawRoleId = row.roleId || row.role_id;
    const matchedRoleFilter = roleTypes.find(
      (r) => (r.resource_type || r.resource_type_name) === row.role || Number(r.type_id || r.id) === Number(rawRoleId),
    );
    const resolvedRoleId = matchedRoleFilter
      ? String(matchedRoleFilter.type_id || matchedRoleFilter.id)
      : rawRoleId ? String(rawRoleId) : '';

    const rawVerticalId = row.verticalId || row.vertical_id;
    const matchedVerticalFilter = (tbhFilters.employeeVerticals || []).find(
      (v) => v.label === row.vertical || Number(v.value) === Number(rawVerticalId),
    );
    const resolvedVerticalId = matchedVerticalFilter
      ? String(matchedVerticalFilter.value)
      : rawVerticalId ? String(rawVerticalId) : '';

    // Handle region and country - check for regionCountryMappingId first
    let resolvedRegionId = '';
    let resolvedCountryId = '';

    const mappingId = row.regionCountryMappingId || row.region_country_mapping_id;
    if (mappingId) {
      const mapping = regionCountryMapping.find(rc => Number(rc.id) === Number(mappingId));
      if (mapping) {
        resolvedRegionId = String(mapping.region_id);
        resolvedCountryId = String(mapping.country_id);
      }
    }

    // Fallback to direct region/country IDs if mapping not found
    if (!resolvedRegionId) {
      const rawRegionId = row.regionId || row.region_id;
      resolvedRegionId = rawRegionId ? String(rawRegionId) : '';
    }

    if (!resolvedCountryId) {
      const rawCountryId = row.countryId || row.country_id;
      resolvedCountryId = rawCountryId ? String(rawCountryId) : '';
    }

    const resolvedScrumId = row.scrumTeamId || row.scrum_team_id || row.scrumId ? String(row.scrumTeamId || row.scrum_team_id || row.scrumId) : '';
    const resolvedTbhId = row.tbhId || (row.id ? `TBH-${row.id}` : '');

    const rawExpId = row.experience_id || row.experienceId || row.res_exp_id;
    const matchedExperience = allExperienceOptions.find(
      (opt) => String(opt.value) === String(rawExpId)
        || String(opt.label || '').trim()
          .toLowerCase() === String(row.experience || '').trim()
          .toLowerCase(),
    );
    const resolvedExperience = matchedExperience
      ? String(matchedExperience.value)
      : (rawExpId ? String(rawExpId) : '');

    const rawLocationId = row.location_id || row.locationId;
    const matchedLocation = locationOptions.find(
      (opt) => String(opt.value) === String(rawLocationId)
        || String(opt.label || '').trim()
          .toLowerCase() === String(row.location || '').trim()
          .toLowerCase(),
    );
    const resolvedLocationId = matchedLocation
      ? String(matchedLocation.value)
      : (rawLocationId ? String(rawLocationId) : '');

    const resolvedDepartmentId = row.departmentId || row.department_id ? String(row.departmentId || row.department_id) : '';

    const rawPct = row.allocationPct;
    const resolvedPct = rawPct !== undefined && rawPct !== null
      ? Number(String(rawPct).replace('%', '')) || 100
      : 100;

    setTbhForm({
      requestId: String(row.requestId || row.request_id || ''),
      tbhId: resolvedTbhId,
      verticalId: resolvedVerticalId,
      regionId: resolvedRegionId,
      countryId: resolvedCountryId,
      roleId: resolvedRoleId,
      experience: resolvedExperience,
      allocationPct: resolvedPct,
      allocationStartDate: row.allocationStartDate || row.allocation_start_date
        ? dayjs(row.allocationStartDate || row.allocation_start_date)
        : null,
      allocationEndDate: row.allocationEndDate || row.allocation_end_date
        ? dayjs(row.allocationEndDate || row.allocation_end_date)
        : null,
      scrumId: resolvedScrumId,
      remark: row.remark || row.remarks || '',
      locationId: resolvedLocationId,
      departmentId: resolvedDepartmentId,
    });
    setErrors({});
    // Keep fields disabled in edit mode if they have a TBH ID (fields were auto-populated)
    setTbhAutoPopulated(Boolean(resolvedTbhId));
    setTbhModal({ isOpen: true, mode: ACTIONS.EDIT, row });
  };

  const submitTbh = async (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!tbhForm.tbhId) nextErrors.tbhId = 'TBH Id is required';
    if (!tbhForm.roleId) nextErrors.roleId = 'Role is required';
    if (!tbhForm.verticalId) nextErrors.verticalId = 'Vertical is required';
    if (!tbhForm.regionId) nextErrors.regionId = 'Region is required';
    if (tbhForm.regionId && !tbhForm.countryId) nextErrors.countryId = 'Country is required';
    if (
      tbhForm.allocationPct === ''
      || tbhForm.allocationPct === null
      || tbhForm.allocationPct === undefined
    ) {
      nextErrors.allocationPct = 'Allocation % is required';
    }
    if (!tbhForm.allocationStartDate) nextErrors.allocationStartDate = 'Start Date is required';
    if (!tbhForm.allocationEndDate) nextErrors.allocationEndDate = 'End Date is required';
    if (!tbhForm.scrumId) nextErrors.scrumId = 'Scrum is required';
    if (!tbhForm.remark) nextErrors.remark = 'Comments are required';
    if (!tbhForm.locationId) nextErrors.locationId = 'Location is required';
    if (!tbhForm.departmentId) nextErrors.departmentId = 'Department is required';
    if (!tbhForm.experience) nextErrors.experience = 'Employee Experience is required';
    if (
      tbhForm.allocationStartDate
      && tbhForm.allocationEndDate
      && dayjs(tbhForm.allocationStartDate).isAfter(dayjs(tbhForm.allocationEndDate))
    ) {
      nextErrors.allocationEndDate = 'End Date cannot be before Start Date';
    }

    if (tbhForm.tbhId && tbhForm.allocationPct !== '' && tbhForm.allocationPct !== null && tbhForm.allocationPct !== undefined) {
      const currentTbhId = tbhForm.tbhId;
      const currentAllocationId = tbhModal.mode === ACTIONS.EDIT ? tbhModal.row?.id : null;

      (tbhAllocations || []).forEach((row) => {
        if (currentAllocationId && Number(row.id) === Number(currentAllocationId)) return;

        const normSelected = String(currentTbhId)
          .replace(/^TBH-/, '')
          .trim();
        const normRow = String(row.tbhId || row.tbh_id || '')
          .replace(/^TBH-/, '')
          .trim();

        if (normSelected === normRow && normSelected !== '') {
          // const pct = Number(String(row.allocationPct || row.allocation_pct || '0').replace('%', '')) || 0;
          // existingAllocationPct += pct;
        }
      });
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    const payload = {
      project_id: Number(selectedProjectId),
      request_id: tbhForm.requestId ? Number(tbhForm.requestId) : null,
      vertical_id: tbhForm.verticalId ? Number(tbhForm.verticalId) : null,
      region_id: tbhForm.regionId ? Number(tbhForm.regionId) : null,
      country_id: tbhForm.countryId ? Number(tbhForm.countryId) : null,
      role_id: tbhForm.roleId ? Number(tbhForm.roleId) : null,
      experience_id: tbhForm.experience ? Number(tbhForm.experience) : null,
      locationId: tbhForm.locationId ? Number(tbhForm.locationId) : null,
      departmentId: tbhForm.departmentId ? Number(tbhForm.departmentId) : null,
      allocation_pct: Number(tbhForm.allocationPct),
      allocation_start_date: dayjs(tbhForm.allocationStartDate).format('YYYY-MM-DD'),
      allocation_end_date: dayjs(tbhForm.allocationEndDate).format('YYYY-MM-DD'),
      scrum_team_id: Number(tbhForm.scrumId || scrumOptions[0]?.value || 1),
      remark: tbhForm.remark || '',
      is_active: 1,
      tbh_id: tbhForm.tbhId ? tbhForm.tbhId.replace(/^TBH-/, '') : '',
    };

    setIsLoading(true);
    try {
      let res = null;
      if (tbhModal.mode === ACTIONS.EDIT) {
        res = await UseAxios(updateTbhResourceAllocation(tbhModal.row.id, payload));
      } else {
        res = await UseAxios(createTbhResourceAllocation(payload));
      }

      if (res && res.status >= 200 && res.status < 300) {
        toast.success(tbhModal.mode === ACTIONS.EDIT ? 'TBH resource allocation updated successfully' : 'TBH resource allocation added successfully');
        setTbhModal({ isOpen: false, mode: ACTIONS.ADD, row: null });
        refreshProjectData();
      } else {
        let errorMsg = '';
        if (res?.data?.response?.data?.message) {
          errorMsg = res.data.response.data.message;
        } else if (res?.data?.response?.data?.error) {
          errorMsg = res.data.response.data.error;
        } else if (res?.data?.message && !/status code/i.test(res.data.message)) {
          errorMsg = res.data.message;
        } else {
          errorMsg = 'Failed to save TBH resource allocation';
        }
        toast.error(errorMsg);
      }
    } catch (err) {
      let errorMsg = '';
      if (err?.response?.data?.message) {
        errorMsg = err.response.data.message;
      } else if (err?.response?.data?.error) {
        errorMsg = err.response.data.error;
      } else if (err?.message && !/status code/i.test(err.message)) {
        errorMsg = err.message;
      } else {
        errorMsg = 'Error submitting TBH allocation';
      }
      console.error('Error submitting TBH allocation:', err);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = async () => {
    const startDate = deleteModal.type === 'tbh'
      ? deleteModal.row?.allocationStartDate
      : deleteModal.row?.startDate;
    if (isAllocationStartDateBeforeToday(startDate)) {
      toast.error(PAST_ALLOCATION_DELETE_MESSAGE);
      setDeleteModal({ isOpen: false, type: 'standard', row: null });
      return;
    }

    setIsLoading(true);
    try {
      let res = null;
      if (deleteModal.type === 'tbh') {
        res = await UseAxios(deleteTbhResourceAllocation(deleteModal.row.id));
      } else {
        res = await UseAxios(deleteResourceAllocation(deleteModal.row.allocationId));
      }

      if (res && res.status >= 200 && res.status < 300) {
        toast.success(deleteModal.type === 'tbh' ? 'TBH resource allocation deleted successfully' : 'Resource allocation deleted successfully');
        setDeleteModal({ isOpen: false, type: 'standard', row: null });
        refreshProjectData();
      } else {
        const errorMsg = res?.data?.message || res?.data?.response?.data?.message || 'Failed to delete allocation';
        toast.error(errorMsg);
      }
    } catch (err) {
      console.error('Error deleting allocation:', err);
      toast.error(err?.response?.data?.message || 'Error deleting allocation');
    } finally {
      setIsLoading(false);
    }
  };

  const formattedAllocations = useMemo(() => {
    return buildAllocationTableData(
      allocations,
      handleOpenAllocationEdit,
      (row) => handleOpenDelete('standard', row),
      roleTypes,
      scrumList,
      permissions,
      selectedResourceRowDetails,
      setSelectedResourceRowDetails,
    );
  }, [allocations, roleTypes, scrumList, permissions, selectedResourceRowDetails]);

  const formattedTbhAllocations = useMemo(() => {
    const filteredRows = (tbhAllocations || []).filter(
      (row) => Number(row.projectId || row.project_id) === Number(selectedProjectId),
    );
    const result = buildTbhTableData(
      filteredRows,
      handleOpenTbhEdit,
      (row) => handleOpenDelete('tbh', row),
      projectList,
      projectMetadata,
      tbhFilters,
      roleTypes,
      scrumList,
      permissions,
      regionCountryMapping,
      experienceLevel,
      locationTypes,
      selectedTbhRowDetails,
      setSelectedTbhRowDetails,
    );
    return result;
  }, [tbhAllocations, selectedProjectId, projectList, projectMetadata, tbhFilters, roleTypes, scrumList, permissions, regionCountryMapping, experienceLevel, locationTypes, selectedTbhRowDetails]);

  const buildGridConfiguration = (columns, pageSize = 10, showPagination = false, paginationConfig = undefined) => ({
    generalSettings: {
      enableApiFiltering: false,
      baseURL: '',
      showToolBar: false,
      showPagination: showPagination,
      showTieredMenu: false,
      userInfo: {
        emailId: userProfile?.email || '',
        permissions: userProfile?.permissions || [],
        roleDetails: userProfile?.roleDetails || {},
        employeeId: userProfile?.employeeId || '',
      },
      headers: {},
      apiEndpoints: {
        getAllViews: { endpoint: '', enabled: false },
        getFilteredData: { endpoint: '', enabled: false },
        saveOrUpdateView: { endpoint: '', enabled: false },
        deleteView: { endpoint: '', enabled: false },
        download: { endpoint: '', enabled: false },
      },
      toolBarSettings: {
        showAddNew: false,
        showDownloadExcel: false,
        showColumnCustomize: false,
        showColumnFilterMenu: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showReset: false,
        showExpandCollapse: false,
        showFilterOption: false,
        showToolBarHeading: false,
        toolBarHeading: '',
      },
    },
    tableSettings: {
      size: 'small',
      pageSize,
      tableConfig: columns,
      tableScrollHeight: '360px',
      loaderSkeleton: { rows: 5, bodyCells: columns.length, columns: columns.length },
      paginationConfig: paginationConfig,
      showExpandCollapse: false,
      maxFrozenColumns: { desktop: 0, tablet: 0, mobile: 0 },
    },
  });

  const allocationTableColumns = useMemo(() => {
    const canAction = permissions.update || permissions.delete;
    return canAction ? [ROW_SELECTOR_COLUMN, ...BASE_ALLOCATION_TABLE_COLUMNS, ALLOCATION_ACTION_COLUMN] : BASE_ALLOCATION_TABLE_COLUMNS;
  }, [permissions.update, permissions.delete]);

  const tbhTableColumns = useMemo(() => {
    const canAction = permissions.update || permissions.delete;
    return canAction ? [ROW_SELECTOR_COLUMN, ...BASE_TBH_TABLE_COLUMNS, TBH_ACTION_COLUMN] : BASE_TBH_TABLE_COLUMNS;
  }, [permissions.update, permissions.delete]);

  const allocationsPageSize = Math.max(formattedAllocations.length, 1);
  const tbhPageSize = Math.max(formattedTbhAllocations.length, 1);

  const allocationsGridConfig = useMemo(
    () => buildGridConfiguration(
      allocationTableColumns,
      allocationsPageSize,
      false,
      { page: 1, limit: allocationsPageSize },
    ),
    [userProfile, allocationTableColumns, allocationsPageSize],
  );
  const tbhGridConfig = useMemo(
    () => buildGridConfiguration(
      tbhTableColumns,
      tbhPageSize,
      false,
      { page: 1, limit: tbhPageSize },
    ),
    [userProfile, tbhTableColumns, tbhPageSize],
  );

  useEffect(() => {
    if (!lottieContainerRef.current || selectedProjectId) return;
    import('../../../Assets/images/json/dar_milestone_details_load.json').then(
      ({ default: animationData }) => {
        if (lottieAnimRef.current) {
          lottieAnimRef.current.destroy();
        }
        lottieAnimRef.current = lottie.loadAnimation({
          container: lottieContainerRef.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData,
        });
      },
    );
    return () => {
      if (lottieAnimRef.current) {
        lottieAnimRef.current.destroy();
        lottieAnimRef.current = null;
      }
    };
  }, [selectedProjectId]);

  const toolbarTableConfig = useMemo(() => ([
    {
      field: 'project.projectName',
      header: 'Project Name',
      visible: true,
      filter: true,
      isGlobalFilter: true,
      isMandatory: true,
      menuItems: [
        {
          label: 'Project Name',
          items: [
            {
              type: 'filter',
              field: 'project.projectName',
              template: 'singleSelect',
              label: 'Project Name',
              placeholder: 'Select Project Name',
              options: undefined,
              selectedValues: [],
              selectedValue: null,
              selectedLabel: '',
              isRequired: true,
              isMandatory: true,
              requiredOnMainApply: true,
              requiredMessage: 'Select Project Name before applying filters.',
              url: `${RA_TOOLBAR_BASE_URL}/filter/project-names`,
              tableUtilityConfig: {
                isMandatory: true,
                requiredOnMainApply: true,
                requiredValidationMessage: 'Select Project Name before applying filters.',
              },
            },
          ],
        },
      ],
    },
    {
      field: 'basicDetails.vertical',
      header: 'Project Vertical',
      visible: true,
      filter: true,
      isGlobalFilter: true,
      menuItems: [
        {
          label: 'Project Vertical',
          items: [
            {
              type: 'filter',
              field: 'basicDetails.vertical',
              template: 'multiSelect',
              label: 'Project Vertical',
              placeholder: 'Select Project Vertical',
              options: [],
              selectedValues: [],
              selectedValue: null,
              selectedLabel: '',
              url: `${RA_TOOLBAR_BASE_URL}/filter/vertical-names`,
              dependentFieldsToReset: ['project.projectName'],
            },
          ],
        },
      ],
    },
    {
      field: 'basicDetails.type',
      header: 'Project Type',
      visible: true,
      filter: true,
      isGlobalFilter: true,
      menuItems: [
        {
          label: 'Project Type',
          items: [
            {
              type: 'filter',
              field: 'basicDetails.type',
              template: 'multiSelect',
              label: 'Project Type',
              placeholder: 'Select Project Type',
              options: [],
              selectedValues: [],
              selectedValue: null,
              selectedLabel: '',
              url: `${RA_TOOLBAR_BASE_URL}/filter/project-type`,
              dependentFieldsToReset: ['project.projectName'],
            },
          ],
        },
      ],
    },
    {
      field: 'project.status',
      header: 'Project Status',
      visible: true,
      filter: true,
      isGlobalFilter: true,
      menuItems: [
        {
          label: 'Project Status',
          items: [
            {
              type: 'filter',
              field: 'project.status',
              template: 'multiSelect',
              label: 'Project Status',
              placeholder: 'Select Project Status',
              options: [],
              selectedValues: [],
              selectedValue: null,
              selectedLabel: '',
              url: `${RA_TOOLBAR_BASE_URL}/filter/project-status`,
              dependentFieldsToReset: ['project.projectName'],
            },
          ],
        },
      ],
    },
  ]), []);

  const handleToolbarFilteredApiRequest = useCallback((requestData) => {
    const activeFilters = requestData?.filter || [];
    hasActiveFiltersRef.current = activeFilters.length > 0;
    window.updateRAFilterButtonState?.();
    const projectFilterItem = activeFilters.find(
      (fi) => fi?.field === 'project.projectName' || fi?.field === 'projectName',
    );

    if (projectFilterItem) {
      const selectedVal = projectFilterItem.selectedValue
        || (Array.isArray(projectFilterItem.selectedValues) && projectFilterItem.selectedValues[0])
        || projectFilterItem.value;

      const selectedProjName = selectedVal?.value || selectedVal;
      if (selectedProjName) {
        const matchedProj = (initialProjectListRef.current.length ? initialProjectListRef.current : projectListRef.current).find((p) => {
          const name = p.project?.projectName || p.project_name || p.projectName || p.name || '';
          return name === selectedProjName;
        });
        const id = matchedProj?.project?.projectId || matchedProj?.project_id || matchedProj?.projectId || matchedProj?.id || '';
        setSelectedProjectId(id ? String(id) : '');
      } else {
        setSelectedProjectId('');
      }
    } else {
      setSelectedProjectId('');
    }

    const enrichedRequest = {
      ...requestData,
      userInfo: {
        emailId: userProfile?.email || '',
        employeeId: userProfile?.employeeId || '',
        empId: userProfile?.employeeId || '',
        isAdmin: userProfile?.isAdmin || false,
        superAdmin: userProfile?.superAdmin || false,
        permissions: userProfile?.permissions || {},
        roleDetails: userProfile?.roleDetails || {},
      },
      payload: {
        ...(requestData?.payload || {}),
        userInfo: {
          emailId: userProfile?.email || '',
          employeeId: userProfile?.employeeId || '',
          empId: userProfile?.employeeId || '',
          isAdmin: userProfile?.isAdmin || false,
          superAdmin: userProfile?.superAdmin || false,
          permissions: userProfile?.permissions || {},
          roleDetails: userProfile?.roleDetails || {},
        },
      },
    };

    return enrichedRequest;
  }, [userProfile]);

  const handleToolbarFilteredApiResponse = useCallback((response) => {
    if (!response) return;

    if (!response.meta) {
      const tempRows = (
        response?.data?.tableData
        || response?.data?.data?.tableData
        || response?.data?.data
        || response?.data
        || []
      );
      const rowCount = Array.isArray(tempRows) ? tempRows.length : 0;
      response.meta = {
        total: rowCount,
        page: 1,
        limit: rowCount || 10,
      };
    }

    const rows = (
      response?.data?.tableData
      || response?.data?.data?.tableData
      || response?.data?.data
      || response?.data
      || []
    );
    const rowArray = Array.isArray(rows) ? rows : [];
    setProjectList(rowArray);
    projectListRef.current = rowArray;

    if (isInitialToolbarLoadRef.current) {
      initialProjectListRef.current = rowArray;
    }

    const activeFilters = response.appliedFilters || [];
    const hasActiveFilters = activeFilters.length > 0;
    hasActiveFiltersRef.current = hasActiveFilters;
    window.updateRAFilterButtonState?.();

    const projectFilterItem = activeFilters.find(
      (fi) => fi?.field === 'project.projectName' || fi?.field === 'projectName',
    );

    if (hasActiveFilters) {
      if (projectFilterItem) {
        const selectedVal = projectFilterItem.selectedValue
          || (Array.isArray(projectFilterItem.selectedValues) && projectFilterItem.selectedValues[0])
          || projectFilterItem.value;

        const selectedProjName = selectedVal?.value || selectedVal;
        if (selectedProjName) {
          const matchedProj = rowArray.find((p) => {
            const name = p.project?.projectName || p.project_name || p.projectName || p.name || '';
            return name === selectedProjName;
          });
          const id = matchedProj?.project?.projectId || matchedProj?.project_id || matchedProj?.projectId || matchedProj?.id || '';
          setSelectedProjectId(id ? String(id) : '');
        } else {
          setSelectedProjectId('');
        }
      } else {
        const firstProj = rowArray[0];
        const firstId = firstProj?.project?.projectId || firstProj?.project_id || firstProj?.projectId || firstProj?.id || '';
        setSelectedProjectId(firstId ? String(firstId) : '');
      }
    } else {
      setSelectedProjectId('');
    }

    const projectNameSelectedValue = projectFilterItem?.selectedValue ?? null;
    const projectNameSelectedValues = projectFilterItem?.selectedValues ?? [];
    const projectNameSelectedLabel = projectFilterItem?.selectedLabel ?? '';

    const tableConfiguration = [
      {
        field: 'project.projectName',
        header: 'Project Name',
        visible: true,
        filter: true,
        isGlobalFilter: true,
        isMandatory: true,
        menuItems: [
          {
            label: 'Project Name',
            items: [
              {
                type: 'filter',
                field: 'project.projectName',
                template: 'singleSelect',
                label: 'Project Name',
                placeholder: 'Select Project Name',
                options: undefined,
                selectedValues: projectNameSelectedValues,
                selectedValue: projectNameSelectedValue,
                selectedLabel: projectNameSelectedLabel,
                isRequired: true,
                isMandatory: true,
                requiredOnMainApply: true,
                requiredMessage: 'Select Project Name before applying filters.',
                url: `${RA_TOOLBAR_BASE_URL}/filter/project-names`,
                tableUtilityConfig: {
                  isMandatory: true,
                  requiredOnMainApply: true,
                  requiredValidationMessage: 'Select Project Name before applying filters.',
                },
              },
            ],
          },
        ],
      },
      {
        field: 'basicDetails.vertical',
        header: 'Project Vertical',
        visible: true,
        filter: true,
        isGlobalFilter: true,
        menuItems: [
          {
            label: 'Project Vertical',
            items: [
              {
                type: 'filter',
                field: 'basicDetails.vertical',
                template: 'multiSelect',
                label: 'Project Vertical',
                placeholder: 'Select Project Vertical',
                options: [],
                selectedValues: [],
                selectedValue: null,
                selectedLabel: '',
                url: `${RA_TOOLBAR_BASE_URL}/filter/vertical-names`,
                dependentFieldsToReset: ['project.projectName'],
              },
            ],
          },
        ],
      },
      {
        field: 'basicDetails.type',
        header: 'Project Type',
        visible: true,
        filter: true,
        isGlobalFilter: true,
        menuItems: [
          {
            label: 'Project Type',
            items: [
              {
                type: 'filter',
                field: 'basicDetails.type',
                template: 'multiSelect',
                label: 'Project Type',
                placeholder: 'Select Project Type',
                options: [],
                selectedValues: [],
                selectedValue: null,
                selectedLabel: '',
                url: `${RA_TOOLBAR_BASE_URL}/filter/project-type`,
                dependentFieldsToReset: ['project.projectName'],
              },
            ],
          },
        ],
      },
      {
        field: 'project.status',
        header: 'Project Status',
        visible: true,
        filter: true,
        isGlobalFilter: true,
        menuItems: [
          {
            label: 'Project Status',
            items: [
              {
                type: 'filter',
                field: 'project.status',
                template: 'multiSelect',
                label: 'Project Status',
                placeholder: 'Select Project Status',
                options: [],
                selectedValues: [],
                selectedValue: null,
                selectedLabel: '',
                url: `${RA_TOOLBAR_BASE_URL}/filter/project-status`,
                dependentFieldsToReset: ['project.projectName'],
              },
            ],
          },
        ],
      },
    ];

    if (response.data) {
      response.data.tableConfiguration = tableConfiguration;
      response.data.data = {
        ...(response.data.data || {}),
        tableConfiguration,
      };
    }

    if (isInitialToolbarLoadRef.current) {
      isInitialToolbarLoadRef.current = false;
    }
  }, []);

  const multiTableExportTables = useMemo(() => {
    if (!selectedProjectId) return [];

    const projName = projectMetadata?.projectName || 'Project Details';

    const cleanAllocs = (allocations || []).map((row) => {
      const isPast = row.endDate && new Date(row.endDate) < new Date();
      const status = isPast ? 'Moved Out' : 'Active';

      const matchedRole = roleTypes.find((r) => Number(r.type_id || r.id) === Number(row.resourceType));
      const role = matchedRole ? (matchedRole.resource_type || matchedRole.resource_type_name) : (row.resourceType || '');

      const scrumId = row.scrumId || row.scrum_id;
      let scrumName = row.scrumName || '';
      if (!scrumName && scrumId) {
        const matchedScrum = scrumList.find((s) => Number(s.id) === Number(scrumId));
        scrumName = matchedScrum ? (matchedScrum.name || matchedScrum.label) : String(scrumId);
      }

      const allocVal = Number(row.billability || row.efforts || 0);
      const allocationPct = row.isShadow === 1 ? `${allocVal}% (Shadow)` : `${allocVal}%`;

      return {
        role,
        status,
        resourceName: row.resourceName || '',
        employeeId: row.employeeId || row.empId || '',
        skills: row.skills || '',
        allocationPct,
        startDate: row.startDate ? formatDate(row.startDate) : '',
        endDate: row.endDate ? formatDate(row.endDate) : '',
        remarks: row.remarks || '',
        scrumName,
      };
    });

    const filteredTbhRows = (tbhAllocations || []).filter(
      (row) => Number(row.projectId || row.project_id) === Number(selectedProjectId),
    );

    const cleanTbh = filteredTbhRows.map((row) => {
      const project = (projectList || []).find((p) => Number(p?.project?.projectId || p?.project_id || p?.projectId || p?.id) === Number(row.projectId || row.project_id));
      let projectName = row.projectName || (project ? (project.project?.projectName || project.project_name || project.projectName || project.name) : '') || '';
      if (!projectName && projectMetadata && Number(projectMetadata.projectId || projectMetadata.project_id || projectMetadata.id) === Number(row.projectId || row.project_id)) {
        projectName = projectMetadata.projectName || projectMetadata.project_name || '';
      }

      let role = row.role || '';
      if (!role || typeof role === 'number' || !isNaN(Number(role))) {
        const matchedRole = roleTypes.find((r) => Number(r.type_id || r.id) === Number(row.roleId || row.role));
        if (matchedRole) {
          role = matchedRole.resource_type || matchedRole.resource_type_name;
        }
      }

      let vertical = row.vertical || '';
      const vId = Number(row.verticalId || row.vertical_id);
      if (!vertical && !isNaN(vId)) {
        const matchedVertical = tbhFilters?.employeeVerticals?.find((v) => Number(v.value) === vId);
        if (matchedVertical) vertical = matchedVertical.label;
      }

      // Handle region and country - check for regionCountryMappingId first
      let region = '';
      let country = '';

      const mappingId = row.regionCountryMappingId || row.region_country_mapping_id;
      if (mappingId) {
        const mapping = (regionCountryMapping || []).find((rc) => Number(rc.id) === Number(mappingId));
        if (mapping) {
          region = mapping.region_name || '';
          country = mapping.country_name || '';
        }
      }

      // Fallback to direct region lookup if not found via mapping
      if (!region) {
        const rawRegion = row.regionId ?? row.region_id ?? row.region ?? '';
        const rId = Number(rawRegion);
        if (!isNaN(rId) && rId > 0) {
          const matchedRegion = (regionCountryMapping || []).find((rc) => Number(rc.region_id) === rId);
          if (matchedRegion) region = matchedRegion.region_name;
        }
        if (!region && typeof rawRegion === 'string' && isNaN(Number(rawRegion))) {
          region = rawRegion;
        }
      }

      // Fallback to direct country lookup if not found via mapping
      if (!country) {
        const rawCountry = row.countryId ?? row.country_id ?? row.country ?? '';
        const cId = Number(rawCountry);
        if (!isNaN(cId) && cId > 0) {
          const matchedCountry = (regionCountryMapping || []).find((rc) => Number(rc.country_id) === cId);
          if (matchedCountry) country = matchedCountry.country_name;
        }
        if (!country && typeof rawCountry === 'string' && isNaN(Number(rawCountry))) {
          country = rawCountry;
        }
      }

      let experience = row.experience || '';
      const rawExp = row.experienceId ?? row.experience_id ?? row.res_exp_id;
      const expId = Number(rawExp);
      if (!experience && !isNaN(expId) && expId > 0) {
        const matchedExp = (experienceLevel || []).find((value) => Number(value.id) === expId);
        if (matchedExp) experience = matchedExp.experience_range || '';
      }
      if (!experience && typeof row.experience === 'string' && isNaN(Number(row.experience))) {
        experience = row.experience;
      }

      let location = row.location || '';
      const rawLocation = row.locationId ?? row.location_id;
      const locationId = Number(rawLocation);
      if (!location && !isNaN(locationId) && locationId > 0) {
        const matchedLocation = (locationTypes || []).find((value) => Number(value.id) === locationId);
        if (matchedLocation) location = matchedLocation.location_type || '';
      }
      if (!location && typeof row.location === 'string' && isNaN(Number(row.location))) {
        location = row.location;
      }

      const scrumId = row.scrumTeamId || row.scrum_team_id || row.scrumId;
      const matchedScrum = scrumList.find((s) => Number(s.id) === Number(scrumId));
      const scrumName = matchedScrum ? (matchedScrum.name || matchedScrum.label) : (row.scrumName || scrumId || '');

      return {
        tbhId: row.tbhId || (row.id ? `TBH-${row.id}` : ''),
        projectName,
        staffingRequest: row.staffingRequest || (row.requestId || row.request_id ? `SRN-${row.requestId || row.request_id}` : '') || '',
        vertical,
        region,
        country,
        role,
        experience: experience || '-',
        location: location || '-',
        department: row.department || '',
        allocationPct: row.allocationPct ? (String(row.allocationPct).endsWith('%') ? row.allocationPct : `${row.allocationPct}%`) : '0%',
        startDate: row.allocationStartDate ? formatDate(row.allocationStartDate) : '',
        endDate: row.allocationEndDate ? formatDate(row.allocationEndDate) : '',
        comments: row.remark || row.remarks || '',
        scrumName,
      };
    });

    return [
      {
        heading: 'Unit Allocation Details',
        configuration: {
          generalSettings: {
            enableApiFiltering: false,
            userInfo: {
              emailId: userProfile?.email || '',
              permissions: userProfile?.permissions || [],
              roleDetails: userProfile?.roleDetails || {},
              employeeId: userProfile?.employeeId || '',
            },
            toolBarSettings: {
              toolBarHeading: 'Unit Allocation Details',
              showDownloadExcel: false,
              showMultiTableExport: true,
            },
            apiEndpoints: {
              download: {
                enabled: true,
                filename: () => `Resource_Allocation_Details_${projName.replaceAll(/\s+/g, '_')}`,
                sheetName: () => 'Unit Allocation Details',
                transformResponse: (data) => ({
                  tableConfiguration: allocationTableColumns.filter((c) => c.field !== 'action'),
                  tableData: data || [],
                }),
              },
            },
          },
          tableSettings: {
            tableConfig: allocationTableColumns.filter((c) => c.field !== 'action'),
          },
        },
        data: cleanAllocs,
      },
      {
        heading: 'TBH Resources',
        configuration: {
          generalSettings: {
            enableApiFiltering: false,
            userInfo: {
              emailId: userProfile?.email || '',
              permissions: userProfile?.permissions || [],
              roleDetails: userProfile?.roleDetails || {},
              employeeId: userProfile?.employeeId || '',
            },
            toolBarSettings: {
              toolBarHeading: 'TBH Resources',
              showDownloadExcel: false,
              showMultiTableExport: true,
            },
            apiEndpoints: {
              download: {
                enabled: true,
                filename: () => `Resource_Allocation_Details_${projName.replaceAll(/\s+/g, '_')}`,
                sheetName: () => 'TBH Resources',
                transformResponse: (data) => ({
                  tableConfiguration: tbhTableColumns.filter((c) => c.field !== 'action'),
                  tableData: data || [],
                }),
              },
            },
          },
          tableSettings: {
            tableConfig: tbhTableColumns.filter((c) => c.field !== 'action'),
          },
        },
        data: cleanTbh,
      },
    ];
  }, [selectedProjectId, allocations, tbhAllocations, projectMetadata, roleTypes, scrumList, projectList, tbhFilters, userProfile, regionCountryMapping, experienceLevel]);

  const handleDownloadIconClick = useCallback(() => {
    if (!selectedProjectIdRef.current) {
      toast.warning('Please select a project before exporting.');
      return;
    }
    if (isExporting) return;

    const runExport = async () => {
      setIsExporting(true);
      try {
        const response = await UseAxios(exportResourceAllocation({
          projectId: selectedProjectIdRef.current,
          userInfo: {
            emailId: userProfile?.email || '',
            employeeId: userProfile?.employeeId || '',
            empId: userProfile?.employeeId || '',
            isAdmin: userProfile?.isAdmin || false,
            superAdmin: userProfile?.superAdmin || false,
            permissions: userProfile?.permissions || {},
            roleDetails: userProfile?.roleDetails || {},
          },
        }));

        if (!response?.data?.success) {
          const errorMessage = response?.data?.message
            || response?.data?.response?.data?.message
            || 'Unable to export resource allocation.';
          showDownloadFailureToast(errorMessage);
          return;
        }

        const exportPayload = response.data.data || {};
        const sheets = exportPayload.sheets || [];
        const rowCount = sheets.reduce((total, sheet) => total + (sheet.tableData?.length || 0), 0);
        if (!sheets.length || rowCount === 0) {
          showDownloadFailureToast('No exportable data found for any table.');
          return;
        }

        const orderedSheets = sheets.map((sheet) => {
          const sheetTitle = sheet.title || sheet.sheetName || '';
          if (sheetTitle !== 'TBH Resources') return sheet;
          return {
            ...sheet,
            tableData: orderRowsByVisibleTable(
              sheet.tableData || [],
              formattedTbhAllocations,
              'tbhId',
            ),
          };
        });

        await downloadWorkbook({
          fileName: exportPayload.fileName || 'Resource_Allocation_Details',
          sheets: orderedSheets,
        });
        showDownloadSuccessToast();
      } catch (error) {
        console.error('Error exporting resource allocation:', error);
        showDownloadFailureToast('Unable to export resource allocation.');
      } finally {
        setIsExporting(false);
      }
    };

    runExport();
  }, [formattedTbhAllocations, isExporting, userProfile]);

  const toolbarConfiguration = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      baseURL: RA_TOOLBAR_BASE_URL,
      showToolBar: true,
      showPagination: false,
      showTieredMenu: true,
      userInfo: {
        emailId: userProfile?.email || '',
        permissions: userProfile?.permissions || [],
        roleDetails: userProfile?.roleDetails || {},
        employeeId: userProfile?.employeeId || '',
      },
      headers: { token: userProfile?.access_token },
      apiEndpoints: {
        getAllViews: { endpoint: '', enabled: false },
        getFilteredData: { endpoint: 'filter', enabled: true },
        saveOrUpdateView: { endpoint: '', enabled: false },
        deleteView: { endpoint: '', enabled: false },
        download: { endpoint: 'download', enabled: true },
      },
      handler: {
        handleFilteredApiRequest: handleToolbarFilteredApiRequest,
        handleFilteredApiResponse: handleToolbarFilteredApiResponse,
      },
      handlers: {
        handleDownloadIconClick,
      },
      toolBarSettings: {
        showAddNew: false,
        showDownloadExcel: false,
        showColumnCustomize: false,
        showColumnFilterMenu: true,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showReset: false,
        showExpandCollapse: false,
        showFilterOption: true,
        showToolBarHeading: true,
        toolBarHeading: 'Resource Allocation',
      },
    },
    tableSettings: {
      size: 'small',
      pageSize: 10,
      tableConfig: toolbarTableConfig,
      tableScrollHeight: '0px',
      showExpandCollapse: false,
      loaderSkeleton: { rows: 0, bodyCells: 1, columns: 1 },
      paginationConfig: undefined,
      maxFrozenColumns: { desktop: 0, tablet: 0, mobile: 0 },
    },
  }), [userProfile, toolbarTableConfig, handleToolbarFilteredApiRequest, handleToolbarFilteredApiResponse, handleDownloadIconClick]);

  const canExport = permissions.update || permissions.delete || permissions.create;

  const getValidDayjs = (dateStr) => {
    if (!dateStr || dateStr === '-' || !dayjs(dateStr).isValid()) return null;
    return dayjs(dateStr);
  };

  const getCurrentDateFormatted = () => dayjs();

  const normalizeDateForApi = (value) => {
    if (!value) return '';
    if (dayjs.isDayjs(value)) return value.format('YYYY-MM-DD');
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
  };

  const handleBulkChange = async (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!bulkFormData.endDate) nextErrors.endDate = 'Allocation End Date is required';
    if (!bulkFormData.comments) nextErrors.comments = 'Comments are required';

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }
    const normalizedEndDate = normalizeDateForApi(bulkFormData.endDate);
    const payload = {
      allocationId: selectedResourceRowDetails,
      endDate: normalizedEndDate,
      remarks: bulkFormData.comments,
    };

    setIsLoading(true);
    try {
      setAllocationBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null });
      let res = null;
      res = await UseAxios(updateBulkResourceAllocation(payload));

      if (res?.data?.success) {
        toast.success('Resource allocation updated successfully');
        setSelectedResourceRowDetails([]);
        setBulkFormData({ endDate: '', comments: '' });
        refreshProjectData();
      } else {
        const errorMsg = res?.data?.message || res?.data?.response?.data?.message || 'Failed to save resource allocation';
        toast.error(errorMsg);
      }
    } catch (err) {
      console.error('Error submitting allocation:', err);
      toast.error('Error submitting allocation');
    } finally {
      setIsLoading(false);
    }
  };

  const handleTbhBulkChange = async (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!bulkFormData.endDate) nextErrors.endDate = 'AllocationEnd Date is required';
    if (!bulkFormData.comments) nextErrors.comments = 'Comments are required';

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }
    const normalizedEndDate = normalizeDateForApi(bulkFormData.endDate);
    const payload = {
      allocationId: selectedTbhRowDetails,
      endDate: normalizedEndDate,
      remarks: bulkFormData.comments,
    };

    setIsLoading(true);
    try {
      setTbhBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null });
      let res = null;
      res = await UseAxios(updateBulkTbhResourceAllocation(payload));

      if (res?.status === 200) {
        toast.success('TBH Resource allocation updated successfully');
        setSelectedTbhRowDetails([]);
        setBulkFormData({ endDate: '', comments: '' });
        refreshProjectData();
      } else {
        const errorMsg = res?.data?.message || res?.data?.response?.data?.message || 'Failed to save tbh resource allocation';
        toast.error(errorMsg);
      }
    } catch (err) {
      toast.error('Error submitting allocation');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!permissions.update) return;
    const activeAllocations = (allocations || []).filter(
      (row) => !(row.endDate && new Date(row.endDate) < new Date()),
    );
    const isAllActiveChecked = activeAllocations.length > 0
    && activeAllocations.every((row) => selectedResourceRowDetails.includes(row.allocationId));

    const injectHeaderCheckbox = () => {
      const targetHeaderTh = document.querySelector(
        '#allocation-table-card-container .p-datatable-thead > tr > th:first-child .p-column-header-content',
      );

      if (targetHeaderTh) {
        let wrapperDiv = targetHeaderTh.querySelector('.ra-header-checkbox-wrapper');
        let checkboxInput = null;

        if (!wrapperDiv) {
          targetHeaderTh.innerHTML = '';

          wrapperDiv = document.createElement('div');
          wrapperDiv.className = 'ra-header-checkbox-wrapper';
          wrapperDiv.style.display = 'flex';
          wrapperDiv.style.alignItems = 'center';
          wrapperDiv.style.justifyContent = 'center';
          wrapperDiv.style.width = '100%';
          wrapperDiv.style.height = '100%';
          wrapperDiv.style.minHeight = '36px';

          checkboxInput = document.createElement('input');
          checkboxInput.type = 'checkbox';
          checkboxInput.style.transform = 'scale(1.15)';
          checkboxInput.style.cursor = 'pointer';
          checkboxInput.style.margin = '0';

          wrapperDiv.appendChild(checkboxInput);
          targetHeaderTh.appendChild(wrapperDiv);
        } else {
          checkboxInput = wrapperDiv.querySelector('input[type="checkbox"]');
        }

        if (checkboxInput) {
          checkboxInput.checked = isAllActiveChecked;
          checkboxInput.disabled = activeAllocations.length === 0;
          checkboxInput.style.cursor = activeAllocations.length === 0 ? 'not-allowed' : 'pointer';

          checkboxInput.onclick = (e) => {
            e.stopPropagation();

            flushSync(() => {
              if (isAllActiveChecked) {
                setSelectedResourceRowDetails([]);
              } else {
                setSelectedResourceRowDetails(activeAllocations.map(row => row.allocationId));
              }
            });
          };
        }
        return true;
      }
      return false;
    };

    const initialInjectSuccess = injectHeaderCheckbox();

    let pollingInterval = null;
    if (!initialInjectSuccess) {
      pollingInterval = setInterval(() => {
        const success = injectHeaderCheckbox();
        if (success) {
          clearInterval(pollingInterval);
        }
      }, 100);
    }

    return () => {
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, [allocations, selectedResourceRowDetails]);

  useEffect(() => {
    if (!permissions.update) return;
    const filteredTbhRows = (tbhAllocations || []).filter(
      (row) => Number(row.projectId || row.project_id) === Number(selectedProjectId),
    );

    const isAllTbhChecked = filteredTbhRows.length > 0
    && filteredTbhRows.every((row) => selectedTbhRowDetails.includes(row.id));

    const injectTbhHeaderCheckbox = () => {
      const targetHeaderThInner = document.querySelector(
        '#tbh-table-card-container .p-datatable-thead > tr > th:first-child .p-column-header-content',
      );

      if (targetHeaderThInner) {
        let wrapperDiv = targetHeaderThInner.querySelector('.ra-tbh-header-checkbox-wrapper');
        let checkboxInput = null;

        if (!wrapperDiv) {
          targetHeaderThInner.innerHTML = '';

          wrapperDiv = document.createElement('div');
          wrapperDiv.className = 'ra-tbh-header-checkbox-wrapper';
          wrapperDiv.style.display = 'flex';
          wrapperDiv.style.alignItems = 'center';
          wrapperDiv.style.justifyContent = 'center';
          wrapperDiv.style.width = '100%';
          wrapperDiv.style.height = '100%';
          wrapperDiv.style.minHeight = '36px';

          checkboxInput = document.createElement('input');
          checkboxInput.type = 'checkbox';
          checkboxInput.style.transform = 'scale(1.15)';
          checkboxInput.style.cursor = 'pointer';
          checkboxInput.style.margin = '0';
          checkboxInput.style.padding = '0';

          wrapperDiv.appendChild(checkboxInput);
          targetHeaderThInner.appendChild(wrapperDiv);
        } else {
          checkboxInput = wrapperDiv.querySelector('input[type="checkbox"]');
        }

        if (checkboxInput) {
          checkboxInput.checked = isAllTbhChecked;
          checkboxInput.disabled = filteredTbhRows.length === 0;
          checkboxInput.style.cursor = filteredTbhRows.length === 0 ? 'not-allowed' : 'pointer';

          checkboxInput.onclick = (e) => {
            e.stopPropagation();

            flushSync(() => {
              if (isAllTbhChecked) {
                setSelectedTbhRowDetails([]);
              } else {
                setSelectedTbhRowDetails(filteredTbhRows.map(row => row.id));
              }
            });
          };
        }
        return true;
      }
      return false;
    };

    const initialInjectSuccess = injectTbhHeaderCheckbox();

    let pollingInterval = null;
    if (!initialInjectSuccess) {
      pollingInterval = setInterval(() => {
        const success = injectTbhHeaderCheckbox();
        if (success) {
          clearInterval(pollingInterval);
        }
      }, 100);
    }

    return () => {
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, [tbhAllocations, selectedProjectId, selectedTbhRowDetails]);

  const LocalSkeleton = () => (
    <div className="resource-allocation-skeleton-loader">
      {[1, 2].map((key) => (
        <div key={key} className="resource-allocation-skeleton-card">
          <div className="resource-allocation-skeleton-header">
            <Skeleton width="180px" height="1.5rem" />
            <div className="resource-allocation-skeleton-actions">
              <Skeleton width="80px" height="1.5rem" />
              <Skeleton width="80px" height="1.5rem" />
            </div>
          </div>
          <div className="resource-allocation-skeleton-rows">
            {[1, 2, 3, 4, 5].map((row) => (
              <Skeleton key={row} width="100%" height="2rem" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="resource-allocation-wrapper">
      <div className="ra-toolbar-utility">
        <TableUtility configuration={toolbarConfiguration} showFilterOption />
      </div>

      {!selectedProjectId ? (
        <div className="resource-allocation-placeholder">
          <div className="ra-empty-animation" ref={lottieContainerRef} />
          <p className="placeholder-text">Please select a project to view allocation details.</p>
        </div>
      ) : (
        isLoading ? <LocalSkeleton />
          : <>
            <div className="resource-allocation-content">
              {projectMetadata && (
                <div className="project-details-outer-card">
                  <div className="project-details-section">
                    <h2 className="section-title">Project Details</h2>
                    <div className="project-details-cards-container">
                      <div className="details-sub-card basic-details-card">
                        <div className="sub-card-title-row">
                          <h3 className="sub-card-title">Basic details</h3>
                          <hr className="sub-card-divider" />
                        </div>
                        <div className="detail-rows-container">
                          <div className="detail-row highlighted-row">
                            <span className="detail-label">Project Name</span>
                            <span className="detail-value">{projectMetadata.projectName}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Status</span>
                            <span className={`detail-value status-value ${(projectMetadata.status || '').toLowerCase().replace(/\s+/g, '-')}`}>
                              {projectMetadata.status}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Vertical</span>
                            <span className="detail-value">{projectMetadata.vertical}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Type</span>
                            <span className="detail-value">{projectMetadata.type}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Duration / Efforts</span>
                            <span className="detail-value">{projectMetadata.durationEfforts || '0 days'}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">No. of Resources</span>
                            <span className="detail-value">{projectMetadata.noOfResources || '0'}</span>
                          </div>
                        </div>
                      </div>

                      <div className="details-sub-card pm-card">
                        <div className="sub-card-title-row">
                          <h3 className="sub-card-title">Sr Manager / Manager</h3>
                          <hr className="sub-card-divider" />
                        </div>
                        <div className="managers-scroll-list">
                          {Array.from(new Set(projectMetadata.managers || [])).map((manager, idx) => (
                            <div key={idx} className="manager-name-item">
                              <span className="manager-name">{manager}</span>
                            </div>
                          ))}
                          {(!projectMetadata.managers || projectMetadata.managers.length === 0) && (
                            <div className="no-managers-assigned">No managers assigned</div>
                          )}
                        </div>
                      </div>

                      <div className="details-sub-card timeline-card">
                        <div className="sub-card-title-row">
                          <h3 className="sub-card-title">Timeline</h3>
                          <hr className="sub-card-divider" />
                        </div>
                        <div className="detail-rows-container">
                          <div className="detail-row">
                            <span className="detail-label">BLSD:</span>
                            <span className="detail-value">{formatDate(projectMetadata.blsd)}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">BLED:</span>
                            <span className="detail-value">{formatDate(projectMetadata.bled)}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">ACSD:</span>
                            <span className="detail-value">{formatDate(projectMetadata.acsd)}</span>
                          </div>
                          <div className={`detail-row ${projectMetadata.rped && dayjs().isAfter(dayjs(projectMetadata.rped), 'day') ? 'red-text-row' : ''}`}>
                            <span className="detail-label">RPED:</span>
                            <span className="detail-value">{formatDate(projectMetadata.rped)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="data-table-card" id="allocation-table-card-container">
                <div className="card-header">
                  <h2>Unit Allocation Details</h2>
                  <div>
                    {permissions.update && (
                      <div className= "resource-alloc-bulk-right-wrapper">
                        <span className="alloc-bulk-change-info">Number of resources selected: {selectedResourceRowDetails.length}</span>
                        <button type="button"
                          disabled={!selectedResourceRowDetails.length}
                          className={`alloc-bulk-change-btn ${!selectedResourceRowDetails.length ? 'disabled' : ''}`}
                          onClick={() => handleOpenAllocationBulkChange()}>
                          Bulk Change
                        </button>
                      </div>
                    )}
                    {permissions.create && (
                      <button type="button" className="btn-add-resource-icon" onClick={handleOpenAllocationAdd} title={isFpp ? 'Add Resource FPP' : 'Add Resource T&M'}>
                        <i className="pi pi-plus" />
                      </button>
                    )}
                  </div>
                </div>
                <div className="table-wrapper">
                  <TableUtility
                    key={`allocations-${allocationsPageSize}`}
                    configuration={allocationsGridConfig}
                    data={formattedAllocations}
                    loading={isLoading}
                  />
                </div>
              </div>

              <div className="data-table-card" id="tbh-table-card-container">
                <div className="card-header">
                  <h2>TBH Resources</h2>
                  <div>
                    {permissions.update && (
                      <div className= "resource-alloc-bulk-right-wrapper">
                        <span className="alloc-bulk-change-info">Number of resources selected: {selectedTbhRowDetails.length}</span>
                        <button type="button"
                          disabled={!selectedTbhRowDetails.length}
                          className={`alloc-bulk-change-btn ${!selectedTbhRowDetails.length ? 'disabled' : ''}`}
                          onClick={() => handleOpenTbhBulkChange()}>
                          Bulk Change
                        </button>
                      </div>
                    )}
                    {permissions.create && (
                      <button type="button" className="btn-add-resource-icon" onClick={handleOpenTbhAdd} title="Add TBH Resource">
                        <i className="pi pi-plus" />
                      </button>
                    )}
                  </div>
                </div>
                <div className="table-wrapper">
                  <TableUtility
                    key={`tbh-allocations-${tbhPageSize}`}
                    configuration={tbhGridConfig}
                    data={formattedTbhAllocations}
                    loading={isLoading}
                  />
                </div>
              </div>
            </div>
          </>
      )}

      {/* bulk change dialog for unit Allocation */}
      <Dialog
        className="update-resource-allocation-dialog"
        header="Change Allocation"
        style={{ width: '50vw', maxWidth: '95vw' }}
        breakpoints={{
          '960px': '75vw',
          '768px': '95vw',
          '560px': '100vw',
        }}
        modal
        visible={allocationBulkChangeModal.isOpen}
        onHide={() => setAllocationBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null })}
        blockScroll={true}
        footer={(
          <div className="custom-dialog-footer">
            <button
              type="button"
              className="p-button p-component p-button-secondary"
              onClick={() => setAllocationBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null })}
            >
              Cancel
            </button>

            <button
              type="button"
              className="p-button p-component p-button-primary"
              onClick={handleBulkChange}
            >
              Save
            </button>
          </div>
        )}
      >
        <div className="details-wrapper">
          <h3>No of resources selected :</h3>
          <span>{selectedResourceRowDetails.length}</span>
        </div>

        <div className="form-field required-asterisk">
          <CustomDatePicker
            label="Allocation End Date *"
            value={getValidDayjs(bulkFormData.endDate)}
            minDate={getCurrentDateFormatted()}
            onChange={(value) => {
              setBulkFormData((prev) => ({
                ...prev,
                endDate: normalizeDateForApi(value),
              }));
              setErrors((prev) => ({
                ...prev,
                endDate: undefined,
              }));
            }}
            displayFormat="DD-MM-YYYY"
          />
          {errors.endDate && <small className="error-text">{errors.endDate}</small>}
        </div>

        <div className="form-field full-width">
          <label>Comments *</label>

          <InputTextarea
            rows={4}
            placeholder="Enter..."
            className="comment-text-area"
            value={bulkFormData.comments}
            onChange={(event) => {
              setBulkFormData((prev) => ({
                ...prev,
                comments: event.target.value,
              }));
              setErrors((prev) => ({
                ...prev,
                comments: undefined,
              }));
            }}
          />
          {errors.comments && <small className="error-text">{errors.comments}</small>}

        </div>
      </Dialog>

      {/* bulk change dialog for TBH Allocation */}
      <Dialog
        className="update-resource-allocation-dialog"
        header="Change Allocation"
        style={{ width: '50vw', maxWidth: '95vw' }}
        breakpoints={{
          '960px': '75vw',
          '768px': '95vw',
          '560px': '100vw',
        }}
        modal
        visible={tbhBulkChangeModal.isOpen}
        onHide={() => setTbhBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null })}
        blockScroll={true}
        footer={(
          <div className="custom-dialog-footer">
            <button
              type="button"
              className="p-button p-component p-button-secondary"
              onClick={() => setTbhBulkChangeModal({ isOpen: false, mode: ACTIONS.EDIT, row: null })}
            >
              Cancel
            </button>

            <button
              type="button"
              className="p-button p-component p-button-primary"
              onClick={handleTbhBulkChange}
            >
              Save
            </button>
          </div>
        )}
      >
        <div className="details-wrapper">
          <h3>No of resources selected :</h3>
          <span>{selectedTbhRowDetails.length}</span>
        </div>

        <div className="form-field required-asterisk">
          <CustomDatePicker
            label="Allocation End Date *"
            value={getValidDayjs(bulkFormData.endDate)}
            minDate={getCurrentDateFormatted()}
            onChange={(value) => {
              setBulkFormData((prev) => ({
                ...prev,
                endDate: normalizeDateForApi(value),
              }));
              setErrors((prev) => ({
                ...prev,
                endDate: undefined,
              }));
            }}
            displayFormat="DD-MM-YYYY"
          />
          {errors.endDate && <small className="error-text">{errors.endDate}</small>}
        </div>

        <div className="form-field full-width">
          <label>Comments *</label>

          <InputTextarea
            rows={4}
            placeholder="Enter..."
            className="comment-text-area"
            value={bulkFormData.comments}
            onChange={(event) => {
              setBulkFormData((prev) => ({
                ...prev,
                comments: event.target.value,
              }));
              setErrors((prev) => ({
                ...prev,
                comments: undefined,
              }));
            }}
          />
          {errors.comments && <small className="error-text">{errors.comments}</small>}

        </div>
      </Dialog>

      <Dialog
        header={allocationModal.mode === ACTIONS.EDIT ? (isFpp ? 'Edit Resource FPP' : 'Edit Resource T&M') : (isFpp ? 'Add Resource FPP' : 'Add Resource T&M')}
        visible={allocationModal.isOpen}
        style={{ width: '680px' }}
        onHide={() => setAllocationModal({ isOpen: false, mode: ACTIONS.ADD, row: null })}
        className="premium-dialog resource-allocation-dialog"
      >
        <form onSubmit={submitAllocation} className="dialog-form">
          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="requestId">Staffing Request</label>
              <Dropdown
                id="requestId"
                value={allocationForm.requestId}
                options={staffingOptions}
                onChange={(e) => setAllocationForm({ ...allocationForm, requestId: e.value })}
                placeholder="Select"
                filter
                appendTo="self"
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="resourceType">Role <span className="text-danger">*</span></label>
              <Dropdown
                id="resourceType"
                value={allocationForm.resourceType}
                options={roleOptions}
                onChange={(e) => setAllocationForm({ ...allocationForm, resourceType: e.value })}
                placeholder="Select"
                className={errors.resourceType ? 'p-invalid' : ''}
                appendTo="self"
              />
              {errors.resourceType && <small className="error-text">{errors.resourceType}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="technology">Technology <span className="text-danger">*</span></label>
              <input
                id="technology"
                type="text"
                value={allocationForm.technology}
                onChange={(e) => setAllocationForm({ ...allocationForm, technology: e.target.value })}
                placeholder="Enter technology"
                className={`input-text ${errors.technology ? 'p-invalid-input' : ''}`}
              />
              {errors.technology && <small className="error-text">{errors.technology}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="empId">Employee Name <span className="text-danger">*</span></label>
              <Dropdown
                id="empId"
                value={allocationForm.empId}
                options={employeeOptions}
                onChange={(e) => setAllocationForm({ ...allocationForm, empId: e.value })}
                placeholder="Select"
                filter
                className={errors.empId ? 'p-invalid' : ''}
                disabled={allocationModal.mode === ACTIONS.EDIT}
                appendTo="self"
              />
              {errors.empId && <small className="error-text">{errors.empId}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="billability">Allocation % <span className="text-danger">*</span></label>
              <input
                id="billability"
                type="number"
                min="0"
                max="100"
                value={allocationForm.billability}
                onChange={(e) => setAllocationForm({ ...allocationForm, billability: e.target.value })}
                placeholder="Enter Allocation"
                className={`input-text ${errors.billability ? 'p-invalid-input' : ''}`}
              />
              {errors.billability && <small className="error-text">{errors.billability}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="startDate">Allocation Start Date <span className="text-danger">*</span></label>
              <CustomStyledDatePicker
                id="startDate"
                label=""
                placeholder="Choose Date"
                value={allocationForm.startDate}
                onChange={(date) => setAllocationForm({ ...allocationForm, startDate: date })}
                error={Boolean(errors.startDate)}
                helperText={errors.startDate}
                popperPlacement="top-start"
                disablePopperFlip
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="endDate">Allocation End Date <span className="text-danger">*</span></label>
              <CustomStyledDatePicker
                id="endDate"
                label=""
                placeholder="Choose Date"
                value={allocationForm.endDate}
                onChange={(date) => setAllocationForm({ ...allocationForm, endDate: date })}
                error={Boolean(errors.endDate)}
                helperText={errors.endDate}
                popperPlacement="top-start"
                disablePopperFlip
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="scrumId">Scrum <span className="text-danger">*</span></label>
              <Dropdown
                id="scrumId"
                value={allocationForm.scrumId}
                options={scrumOptions}
                onChange={(e) => setAllocationForm({ ...allocationForm, scrumId: e.value })}
                placeholder="Select"
                className={errors.scrumId ? 'p-invalid' : ''}
                appendTo="self"
              />
              {errors.scrumId && <small className="error-text">{errors.scrumId}</small>}
            </div>
          </div>

          <div className="form-group comments-group">
            <label htmlFor="remarks">Comments <span className="text-danger">*</span></label>
            <input
              id="remarks"
              type="text"
              value={allocationForm.remarks}
              onChange={(e) => setAllocationForm({ ...allocationForm, remarks: e.target.value })}
              className={`input-text ${errors.remarks ? 'p-invalid-input' : ''}`}
              placeholder="Enter..."
            />
            {errors.remarks && <small className="error-text">{errors.remarks}</small>}
          </div>

          <div className="shadow-checkbox-row">
            <input
              id="isShadow"
              type="checkbox"
              checked={allocationForm.isShadow}
              onChange={(e) => setAllocationForm({ ...allocationForm, isShadow: e.target.checked })}
              className="input-checkbox"
            />
            <label htmlFor="isShadow" className="checkbox-label">Shadow Resource</label>
          </div>

          <div className="dialog-footer">
            <button
              type="button"
              className="btn-dialog-secondary"
              onClick={() => setAllocationModal({ isOpen: false, mode: ACTIONS.ADD, row: null })}
            >
              Cancel
            </button>
            <button type="submit" className="btn-dialog-primary">
              {allocationModal.mode === ACTIONS.EDIT ? 'Save' : 'Add'}
            </button>
          </div>
        </form>
      </Dialog>

      <Dialog
        header={tbhModal.mode === ACTIONS.EDIT ? 'Edit TBH Resource' : 'Add TBH Resource'}
        visible={tbhModal.isOpen}
        style={{ width: '680px' }}
        onHide={() => setTbhModal({ isOpen: false, mode: ACTIONS.ADD, row: null })}
        className="premium-dialog resource-allocation-dialog"
      >
        <form onSubmit={submitTbh} className="dialog-form">
          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="requestId">Staffing Request</label>
              <Dropdown
                id="requestId"
                value={tbhForm.requestId}
                options={staffingOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, requestId: e.value }))}
                placeholder="Select"
                filter
                appendTo="self"
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="tbhId">TBH Id <span className="text-danger">*</span></label>
              <Dropdown
                id="tbhId"
                value={tbhForm.tbhId}
                options={tbhIdOptions}
                onChange={(e) => {
                  tbhManualSelectionRef.current = {
                    roleId: false,
                    experience: false,
                  };
                  setTbhForm((prev) => ({
                    ...EMPTY_TBH_FORM,
                    requestId: prev.requestId,
                    tbhId: e.value,
                  }));
                  setTbhAutoPopulated(false);
                }}
                placeholder="Select"
                filter
                className={errors.tbhId ? 'p-invalid' : ''}
                appendTo="self"
              />
              {errors.tbhId && <small className="error-text">{errors.tbhId}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="verticalId">Vertical</label>
              <Dropdown
                id="verticalId"
                value={tbhForm.verticalId}
                options={verticalOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, verticalId: e.value }))}
                placeholder="Select Vertical"
                filter
                className={errors.verticalId ? 'p-invalid' : ''}
                appendTo="self"
                disabled={tbhAutoPopulated}
              />
              {errors.verticalId && <small className="error-text">{errors.verticalId}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="regionId">Region</label>
              <Dropdown
                id="regionId"
                value={tbhForm.regionId}
                options={regionOptions}
                onChange={(e) => setTbhForm((prev) => ({
                  ...prev,
                  regionId: e.value,
                  countryId: '',
                }))}
                placeholder="Select Region"
                filter
                className={errors.regionId ? 'p-invalid' : ''}
                appendTo="self"
                disabled={tbhAutoPopulated}
              />
              {errors.regionId && <small className="error-text">{errors.regionId}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="countryId">Country</label>
              <Dropdown
                id="countryId"
                value={tbhForm.countryId}
                options={countryOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, countryId: e.value }))}
                placeholder="Select Country"
                filter
                disabled={!tbhForm.regionId || tbhAutoPopulated}
                className={errors.countryId ? 'p-invalid' : ''}
                appendTo="self"
              />
              {errors.countryId && <small className="error-text">{errors.countryId}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="roleId">Role</label>
              <Dropdown
                id="roleId"
                value={tbhForm.roleId}
                options={roleOptions}
                onChange={(e) => {
                  tbhManualSelectionRef.current.roleId = true;
                  tbhManualSelectionRef.current.experience = false;
                  updateRoleAndResetExperience(setTbhForm, e.value);
                }}
                placeholder="Select Role"
                className={errors.roleId ? 'p-invalid' : ''}
                appendTo="self"
                disabled={Boolean(tbhForm.tbhId)}
              />
              {errors.roleId && <small className="error-text">{errors.roleId}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="departmentId">Department</label>
              <Dropdown
                id="departmentId"
                value={tbhForm.departmentId}
                options={departmentOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, departmentId: e.value }))}
                placeholder="Select Department"
                filter
                className={errors.departmentId ? 'p-invalid' : ''}
                appendTo="self"
                panelClassName="department-dropdown-panel"
                disabled={tbhAutoPopulated}
              />
              {errors.departmentId && <small className="error-text">{errors.departmentId}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="experience">Employee Experience</label>
              <Dropdown
                id="experience"
                value={tbhForm.experience}
                options={experienceOptions}
                onChange={(e) => {
                  tbhManualSelectionRef.current.experience = true;
                  setTbhForm((prev) => ({ ...prev, experience: e.value }));
                }}
                placeholder="Select Employee Experience"
                className={errors.experience ? 'p-invalid' : ''}
                appendTo="self"
                disabled={!tbhForm.roleId || Boolean(tbhForm.tbhId)}
              />
              {errors.experience && <small className="error-text">{errors.experience}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="locationId">Location</label>
              <Dropdown
                id="locationId"
                value={tbhForm.locationId}
                options={locationOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, locationId: e.value }))}
                placeholder="Select Location"
                filter
                className={errors.locationId ? 'p-invalid' : ''}
                appendTo="self"
                disabled={tbhAutoPopulated}
              />
              {errors.locationId && <small className="error-text">{errors.locationId}</small>}
            </div>
            <div className="form-group col-6">
              <label htmlFor="allocationPct">Allocation % <span className="text-danger">*</span></label>
              <input
                id="allocationPct"
                type="number"
                min="0"
                max="100"
                value={tbhForm.allocationPct}
                onChange={(e) => setTbhForm((prev) => ({
                  ...prev,
                  allocationPct: e.target.value,
                }))}
                placeholder="Enter Allocation %"
                className={`input-text ${errors.allocationPct ? 'p-invalid-input' : ''}`}
              />
              {errors.allocationPct && <small className="error-text">{errors.allocationPct}</small>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="tbhStartDate">Allocation Start Date <span className="text-danger">*</span></label>
              <CustomStyledDatePicker
                id="tbhStartDate"
                label=""
                placeholder="Choose Date"
                value={tbhForm.allocationStartDate}
                onChange={(date) => setTbhForm((prev) => ({
                  ...prev,
                  allocationStartDate: date,
                }))}
                error={Boolean(errors.allocationStartDate)}
                helperText={errors.allocationStartDate}
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="tbhEndDate">Allocation End Date <span className="text-danger">*</span></label>
              <CustomStyledDatePicker
                id="tbhEndDate"
                label=""
                placeholder="Choose Date"
                value={tbhForm.allocationEndDate}
                onChange={(date) => setTbhForm((prev) => ({
                  ...prev,
                  allocationEndDate: date,
                }))}
                error={Boolean(errors.allocationEndDate)}
                helperText={errors.allocationEndDate}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="scrumId">Scrum <span className="text-danger">*</span></label>
              <Dropdown
                id="scrumId"
                value={tbhForm.scrumId}
                options={scrumOptions}
                onChange={(e) => setTbhForm((prev) => ({ ...prev, scrumId: e.value }))}
                placeholder="Select"
                className={errors.scrumId ? 'p-invalid' : ''}
                appendTo="self"
              />
              {errors.scrumId && <small className="error-text">{errors.scrumId}</small>}
            </div>
            <div className="form-group col-6" />
          </div>
          <div className="form-group comments-group">
            <label htmlFor="tbhRemarks">Comments <span className="text-danger">*</span></label>
            <input
              id="tbhRemarks"
              type="text"
              value={tbhForm.remark}
              onChange={(e) => setTbhForm((prev) => ({
                ...prev,
                remark: e.target.value,
              }))}
              placeholder="Enter..."
              className={`input-text ${errors.remark ? 'p-invalid-input' : ''}`}
            />
            {errors.remark && <small className="error-text">{errors.remark}</small>}
          </div>
          <div className="dialog-footer tbh-dialog-footer">
            {Object.keys(errors).length > 0 && (
              <ul className="tbh-validation-errors">
                {Object.values(errors).map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            )}
            <div className="tbh-footer-actions">
              <button
                type="button"
                className="btn-dialog-secondary"
                onClick={() => setTbhModal({ isOpen: false, mode: ACTIONS.ADD, row: null })}
              >
                Cancel
              </button>
              <button type="submit" className="btn-dialog-primary">
                {tbhModal.mode === ACTIONS.EDIT ? 'Update' : 'Add'}
              </button>
            </div>
          </div>
        </form>
      </Dialog>

      <Dialog
        header="Confirm Delete"
        visible={deleteModal.isOpen}
        style={{ width: '400px' }}
        onHide={() => setDeleteModal({ isOpen: false, type: 'standard', row: null })}
        className="premium-dialog delete-confirm-dialog"
      >
        <div className="delete-modal-body">
          <i className="pi pi-exclamation-triangle warning-icon" />
          <p className="warning-text">Are you sure you want to delete this allocation?</p>
        </div>
        <div className="dialog-footer">
          <button
            type="button"
            className="btn-dialog-secondary"
            onClick={() => setDeleteModal({ isOpen: false, type: 'standard', row: null })}
          >
            No
          </button>
          <button type="button" className="btn-dialog-danger" onClick={confirmDelete}>
            Yes, Delete
          </button>
        </div>
      </Dialog>

      <Dialog
        header="Jira Action Status"
        visible={warningModal.isOpen}
        style={{ width: '400px' }}
        onHide={() => setWarningModal({ isOpen: false, message: '' })}
        className="premium-dialog warning-alert-dialog"
      >
        <div className="warning-modal-body">
          <i className="pi pi-info-circle info-icon" />
          <p className="info-text">{warningModal.message}</p>
        </div>
        <div className="dialog-footer">
          <button type="button" className="btn-dialog-primary" onClick={() => setWarningModal({ isOpen: false, message: '' })}>
            OK
          </button>
        </div>
      </Dialog>

      {selectedProjectId && (
        <div ref={hiddenExportUtilityRef} className="ra-hidden-multi-export" style={{ display: 'none' }} aria-hidden="true">
          <TableUtility
            tables={multiTableExportTables}
            showMultiTableExport
            multiTableHeader="Resource Allocation Details"
          />
        </div>
      )}
      {canExport && exportHostElement
        ? createPortal(
          <button
            type="button"
            className="ra-multi-export-btn"
            onClick={handleDownloadIconClick}
            aria-label="Download"
            title={isExporting ? 'Exporting' : 'Download'}
            disabled={isExporting}
          >
            {isExporting ? <i className="pi pi-spinner pi-spin" /> : <img src={resumeDownloadIcon} alt="" className="ra-multi-export-icon" />}
          </button>,
          exportHostElement,
        )
        : null}
    </div>
  );
};

export default ResourceAllocation;
